<template>
  <div class="l-wrapper itinerary" :style="{paddingTop: '0px'}">
    <div
        :class="['itinerary-overlay', {active: openMenu}]"
        @click="openMenu = !openMenu"></div>
    <div class="aside-top">
      <div class="container-fluid">
        <div class="aside-top-content">
          <img
              v-if="branding === 'false'"
              src="/images/itinerary-logo.svg"
              class="aside-top-logo"
              alt="" />
          <img
              v-else-if="branding === 'true'"
              src="/images/luxury-short-safari.svg"
              alt="" />
          <a
              class="aside-top-toggle js-aside-top-toggle"
              @click="openMenu = !openMenu">
            <img src="/images/menu.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
    <main class="main-content">
      <div class="container-lg">
        <div class="itinerary-box" v-if="program">
          <div :class="['itinerary-main', {short: isShort}]">
            <div class="itinerary-main__block">
              <div class="itinerary-main__block-top">
                <img src="/images/tanzania.svg" class="js-lazy" alt="" />
                <h1>
                  {{ $t("itinerary.yourTravel") }}
                  <br />
                  {{ $t("itinerary.toTanzania") }}
                  <span :style="{textTransform: 'none'}">
                    <i>-</i>
                    {{ $tc("common.day", program.header.duration) }}
                    </span
                  >
                </h1>
              </div>
              <div class="itinerary-main__info">
                <div class="itinerary-main__info-item">
                  <div class="itinerary-main__info-item-icon">
                    <i class="icon-user"></i>
                  </div>
                  <div class="itinerary-main__info-item-text">
                    <span>{{ $t("itinerary.programFor") }}</span>
                    {{ program.header.groupName }}
                  </div>
                </div>
                <div class="itinerary-main__info-item">
                  <div class="itinerary-main__info-item-icon">
                    <i class="icon-calendar"></i>
                  </div>
                  <div class="itinerary-main__info-item-text">
                    <span>{{ $t("itinerary.tourDates") }}</span>
                    <div class="itinerary-main__info-item-text-date">
                      {{
                        program.frontendMeta.tourStart &&
                        program.frontendMeta.tourFinish
                            ? program.header.travelDates.start.split(' ')[2] ===
                            program.header.travelDates.finish.split(' ')[2] &&
                            program.header.travelDates.start.split(' ')[1] ===
                            program.header.travelDates.finish.split(' ')[1]
                                ? program.header.travelDates.start.split(' ')[0] +
                                ' - ' +
                                program.header.travelDates.finish.split(' ')[0] +
                                ' ' +
                                program.header.travelDates.finish.split(' ')[1] +
                                ' ' +
                                program.header.travelDates.finish.split(' ')[2]
                                : program.header.travelDates.start.split(' ')[2] ===
                                program.header.travelDates.finish.split(' ')[2]
                                    ? program.header.travelDates.start.split(' ')[0] +
                                    ' ' +
                                    program.header.travelDates.start.split(' ')[1] +
                                    ' - ' +
                                    program.header.travelDates.finish.split(' ')[0] +
                                    ' ' +
                                    program.header.travelDates.finish.split(' ')[1] +
                                    ' ' +
                                    program.header.travelDates.finish.split(' ')[2]
                                    : program.header.travelDates.start +
                                    ' - ' +
                                    program.header.travelDates.finish
                            : $t("itinerary.toBeConfirmed")
                      }}
                    </div>
                  </div>
                </div>
                <div class="itinerary-main__info-item">
                  <div class="itinerary-main__info-item-icon">
                    <i class="icon-peoples"></i>
                  </div>
                  <div
                      class="itinerary-main__info-item-text itinerary-main__info-item-text--capitalize">
                    <span>{{ $t("common.guests") }}</span>
                    {{
                      program.header.guestsCompact
                          .map((item) => `${item.count} ${item.ageName}`)
                          .join(', ')
                    }}
                  </div>
                </div>
                <div class="itinerary-main__info-item">
                  <div class="itinerary-main__info-item-icon">
                    <i class="icon-inbox"></i>
                  </div>
                  <div class="itinerary-main__info-item-text">
                    <span>Email</span>
                    {{ program.header.groupEmail }}
                  </div>
                </div>
              </div>
              <div class="itinerary-main__manager">
                <div class="itinerary-main__manager-photo">
                  <img
                      :src="`${API}/documents/share/images/${program.header.office.manager.photoId}?size=MEDIUM`"
                      class="js-lazy"
                      alt="" />
                </div>
                <div class="itinerary-main__manager-info">
                  <ul>
                    <li>
                      <span>{{ $t("common.yourManager") }}:</span
                      >{{ program.header.office.manager.name }}
                    </li>
                    <li>
                      <span
                      >{{ $t("common.managerContact") }}:</span
                      >
                      <a
                          :href="
                          'tel:' +
                          program.header.office.manager.phone.replaceAll(
                            ' ',
                            ''
                          )
                        ">
                        {{ program.header.office.manager.phone }}</a
                      >
                      <a v-if="program.header.lang === 'RU'"
                         :href="
                          'tg://resolve?domain=' +
                          program.header.office.manager.telegram
                        "
                      ><img
                          src="/images/icons/telegram.svg"
                          class="js-lazy"
                          alt=""
                      /></a>
                      <a
                          :style="{
                          opacity: program.header.office.manager.whatsapp
                            ? 1
                            : 0,
                          visibility: program.header.office.manager.whatsapp
                            ? 'visible'
                            : 'hidden',
                        }"
                          :href="
                          'https://wa.me/' +
                          program.header.office.manager.whatsapp.replaceAll(
                            ' ',
                            ''
                          )
                        "
                      ><img
                          src="/images/icons/whatsapp.svg"
                          class="js-lazy"
                          alt=""
                      /></a>
                    </li>
                    <li>
                      <span>Email:</span
                      ><a href="mailto:office@altezza.travel"
                    >office@altezza.travel</a
                    >
                    </li>
                    <li>
                      <span v-if="branding === 'false'"
                      >{{ $t("common.altezzaHotline") }}:</span
                      >
                      <span v-else-if="branding === 'true'"
                      >{{ $t("common.hotline") }}:</span
                      >
                      <a :href="'tel:' + program.header.office.hotline"
                      >+{{
                          program.header.office.hotline
                              ? new Intl.NumberFormat('ru-RU').format(
                                  +program.header.office.hotline.replace('+', '')
                              )
                              : ''
                        }}</a
                      >
                      <a :href="program.header.office.telegram"
                      ><img
                          src="/images/icons/telegram.svg"
                          class="js-lazy"
                          alt=""
                      /></a>
                      <a
                          :href="program.header.office.whatsapp"
                      ><img
                          src="/images/icons/whatsapp.svg"
                          class="js-lazy"
                          alt=""
                      /></a>
                    </li>
                  </ul>
                  <a
                      v-if="branding === 'false'"
                      :href="
                      program.header.lang !== 'RU'
                        ? `https://altezza.travel/${program.header.lang.toLowerCase()}/terms-and-conditions`
                        : 'https://altezza.travel/terms-and-conditions'
                    "
                      class="itinerary-main__manager-link"
                      target="_blank"
                  ><i class="icon-external-link"></i> Altezza Travel -
                    {{ $t("common.termsAndConditions") }}</a
                  >
                </div>
              </div>
              <div class="kindly-note" v-if="program.header.lang === 'DE'">
                <div class="kindly-note__icon">
                  <img src="/images/icons/messages.svg" class="js-lazy" alt=""/>
                </div>
                <div class="kindly-note__text"> <strong>{{ $t("common.pleaseNote") }}:</strong> {{ $t("itinerary.allEventsEnglish") }}</div>
              </div>
              <div
                  v-if="
                  program.header.totalAmount !== 0 &&
                  !program.frontendMeta.tourStart
                "
                  class="itinerary-main__note">
                <template>
                  <p>
                    {{ $t("itinerary.noteAmountNoDates") }}
                  </p>
                  <p>
                    {{ $t("itinerary.contactManagerToClarifyDates") }}
                  </p>
                </template>
              </div>
            </div>

            <!--!isShort start-->
            <div class="itinerary-days" v-if="!isShort">
              <div
                  class="itinerary-day"
                  v-for="(item, index) in program.body.days"
                  :key="index">
                <div class="itinerary-day__date">
                  <span>
                    <span>{{
                        program.frontendMeta.tourStart
                            ? item.date.split(' ')[0]
                            : index + 1
                      }}</span>
                    {{
                      program.frontendMeta.tourStart
                          ? item.date.split(' ')[1].substring(0, 3)
                          : $t("common.day_one")
                    }}
                  </span>
                  <div class="itinerary-day__date-year">
                    {{item.year ? item.year : program.frontendMeta.tourStart
                      ? program.header.travelDates.start.split(' ')[2]
                      : '-'}}
                  </div>
                </div>

                <div class="itinerary-day__date-to-arrow" v-if="item.dateTo">
                  <svg
                      :style="{marginLeft: '23px'}"
                      width="31px"
                      height="31px"
                      class="icon-newmoon icon-grey">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow-island-to"></use>
                  </svg>
                </div>
                <div v-if="item.dateTo" class="itinerary-day__date-to">
                  <span>
                    <span>{{
                        program.frontendMeta.tourStart
                            ? item.dateTo.split(' ')[0]
                            : index + 1
                      }}</span>
                    {{
                      program.frontendMeta.tourStart
                          ? item.dateTo.split(' ')[1].substring(0, 3)
                          : 'day'
                    }}
                  </span>
                  <div class="itinerary-day__date-year">
                    {{item.year ? item.year : program.frontendMeta.tourStart
                      ? program.header.travelDates.start.split(' ')[2]
                      : '-'}}
                  </div>
                </div>
                <div
                    v-if="transfer.beforeActivity === true"
                    class="itinerary-day__item"
                    v-for="(transfer, idx) in item.transfers.filter(
                    (thing, idx, self) =>
                      idx === self.findIndex((t) => t.name === thing.name)
                  )"
                    :key="idx + 't'">

                  <div v-if="transfer.beforeActivity === true"

                       class="itinerary-day__top"
                       :class="{'itinerary-day__top--padding': !isShort}">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-pickup-car"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.transfer") }}</span>
                        {{ transfer.name }}
                      </h3>
                    </div>
                  </div>
                  <span v-if="transfer.beforeActivity === true"
                        class="itinerary-day__top-duration"
                        :class="{'itinerary-day__top-duration-ru': program.header.lang === 'RU' }"
                  >
                    <i class="icon-clock" :style="{marginTop: '5px'}"></i>
                    <span>{{ $t("common.duration") }}:</span>
                    {{ getTimeFromMins(transfer.duration, program.header.lang)}}
                  </span>
                  <div v-if="transfer.beforeActivity === true" class="itinerary-day__participants">
                    <div class="itinerary-day__participants-title">
                      <a>{{ $t("common.passengers") }}</a>
                      <i class="icon-arrow"></i>
                    </div>
                    <div
                        class="itinerary-day__participants-content"
                        :class="{
                        lowercase:
                          program.header.lang === 'EN' ||
                          program.header.lang === 'RU',
                      }">
                      <template v-for="(n, _ind) in transfer.participantNames">
                        {{ n.replace('(Non-resident)', '')
                        }}{{
                          _ind !== transfer.participantNames.length - 1
                              ? ','
                              : ''
                        }}
                      </template>
                    </div>
                  </div>
                </div>
                <div class="itinerary-day__item" v-if="index === 0 && !program.header.hideWelcomeTexts">
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort}"
                      :style="{paddingTop: '0px'}">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-info icon-info-none icon-info-welcome">
                        <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0)">
                            <path
                                d="M10.4997 15.1664C13.077 15.1664 15.1664 13.077 15.1664 10.4997C15.1664 7.92236 13.077 5.83301 10.4997 5.83301C7.92236 5.83301 5.83301 7.92236 5.83301 10.4997C5.83301 13.077 7.92236 15.1664 10.4997 15.1664Z"
                                fill="white" />
                            <path
                                d="M10.4997 0C9.85534 0 9.33301 0.522334 9.33301 1.16669V2.33338C9.33301 2.97773 9.85534 3.50007 10.4997 3.50007C11.1441 3.50007 11.6664 2.97773 11.6664 2.33338V1.16669C11.6664 0.522334 11.1441 0 10.4997 0Z"
                                fill="white" />
                            <path
                                d="M10.4997 17.5C9.85534 17.5 9.33301 18.0223 9.33301 18.6667V19.8334C9.33301 20.4777 9.85534 21.0001 10.4997 21.0001C11.1441 21.0001 11.6664 20.4777 11.6664 19.8334V18.6667C11.6664 18.0223 11.1441 17.5 10.4997 17.5Z"
                                fill="white" />
                            <path
                                d="M19.8334 9.33301H18.6667C18.0223 9.33301 17.5 9.85534 17.5 10.4997C17.5 11.1441 18.0223 11.6664 18.6667 11.6664H19.8334C20.4777 11.6664 21.0001 11.1441 21.0001 10.4997C21.0001 9.85534 20.4777 9.33301 19.8334 9.33301Z"
                                fill="white" />
                            <path
                                d="M2.33331 9.33301H1.16669C0.522334 9.33301 0 9.85534 0 10.4997C0 11.1441 0.522334 11.6664 1.16669 11.6664H2.33338C2.97773 11.6664 3.50007 11.1441 3.50007 10.4997C3.50007 9.85534 2.97767 9.33301 2.33331 9.33301Z"
                                fill="white" />
                            <path
                                d="M17.8959 3.07556C17.4437 2.63888 16.7269 2.63888 16.2748 3.07556L15.45 3.90038C14.9944 4.35606 14.9946 5.09476 15.4502 5.5503C15.669 5.76898 15.9655 5.89183 16.2749 5.89189C16.5843 5.89183 16.8809 5.76885 17.0997 5.55003L17.9245 4.7252C18.3721 4.26173 18.3593 3.52317 17.8959 3.07556Z"
                                fill="white" />
                            <path
                                d="M5.57909 15.4499C5.13148 14.9865 4.39285 14.9736 3.92945 15.4213C3.91974 15.4307 3.91017 15.4402 3.9008 15.4499L3.07591 16.2748C2.61243 16.7224 2.59958 17.4609 3.04727 17.9244C3.49488 18.3879 4.23351 18.4007 4.69692 17.953C4.70662 17.9437 4.71619 17.9341 4.72556 17.9244L5.55038 17.0996C6.01386 16.652 6.02671 15.9134 5.57909 15.4499Z"
                                fill="white" />
                            <path
                                d="M17.925 16.2754L17.1002 15.4505C16.6367 15.0029 15.8981 15.0158 15.4505 15.4792C15.0139 15.9314 15.0139 16.6481 15.4505 17.1002L16.2753 17.925C16.7388 18.3726 17.4774 18.3598 17.925 17.8963C18.3617 17.4442 18.3617 16.7275 17.925 16.2754Z"
                                fill="white" />
                            <path
                                d="M5.57874 3.92907C5.56931 3.91937 5.55974 3.9098 5.55003 3.90036L4.72521 3.07554C4.26173 2.62792 3.52317 2.64077 3.07556 3.10418C2.63888 3.55631 2.63888 4.27306 3.07556 4.72519L3.90038 5.55001C4.348 6.01349 5.08655 6.02634 5.55003 5.57872C6.01351 5.13111 6.02636 4.39255 5.57874 3.92907Z"
                                fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="21" height="21" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        {{ $t("common.welcomeToSunnyTanzania") }}
                      </h3>
                    </div>
                  </div>
                  <div class="itinerary-day__content">
                    <p v-html="program.header.welcomeText"></p>
                  </div>
                </div>
                <div
                    class="itinerary-day__item itinerary-day__item-scroll"
                    v-for="(day, idx) in item.dayInfo"
                    :key="idx + 'd'"
                    :id="
                    'day' +
                    JSON.stringify(
                      program.body.days
                        .slice(0, index)
                        .map((day) => (day.dayInfo ? day.dayInfo.length : 0))
                        .reduce((acc, value) => acc + value, 0) +
                        idx +
                        1
                    )
                  ">
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      :style="
                      day.type === 'INFO' &&
                      !day.description &&
                      !day.additionalNotes
                        ? {paddingTop: '30px'}
                        : {}
                    "
                      v-if="
                      day.type === 'ARRIVAL' ||
                      day.type === 'DEPARTURE' ||
                      day.type === 'FLIGHT'
                    ">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-airplane"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>{{ day.name }}</h3>
                    </div>
                  </div>
                  <div
                      v-if="day.type === 'FLIGHT'"
                      class="itinerary-day__top-duration"
                      :class="{'itinerary-day__top-duration-ru': program.header.lang === 'RU' }"
                  >
                    <div class="itinerary-day__top-duration-dep">
                      <i class="icon-clock" :style="{marginTop: '5px'}"></i>
                      <span>{{ $t("common.departureTime") }}:</span
                      >
                      {{
                        day.departureTime
                            ? day.departureTime.substring(0, 2) +
                            ':' +
                            day.departureTime.substring(
                                day.departureTime.length - 2
                            )
                            : ''
                      }}
                    </div>
                    <div class="itinerary-day__top-duration-dur">

                      <!-- <i class="icon-clock" :style="{marginTop: '5px'}"></i>  -->
                      <!-- <span>Arrival time:</span>{{day.arrivalTime ? day.arrivalTime.substring(0, 2) + ':' + day.arrivalTime.substring(day.arrivalTime.length - 2) : ''}} -->
                      <span>{{ $t("common.duration") }}:</span
                      >{{calculateHours(day.duration)}}
                      {{calculateMinutes(day.duration)}}
                    </div>
                  </div>
                  <div class="test" v-if="day.type === 'FLIGHT' && day.plane" style="padding-left: 48px;">
                    <div class="aircraft">
                      <div class="aircraft__plane-wrapper">
                        <div class="aircraft__image">
                          <img
                              :src="`${API}/documents/share/images/${day.plane.photo}?size=MEDIUM`"
                              class="js-lazy"
                              :alt="day.plane.airline" />
                        </div>
                        <div class="aircraft__info-wrapper">
                          <div class="aircraft__text" v-if="day.plane.airline">
                            {{ $t("common.airline") }}: {{day.plane.airline}}
                          </div>
                          <div class="aircraft__text" v-if="day.plane.aircraft">
                            {{ $t("common.aircraft") }}: {{day.plane.aircraft}}
                          </div>
                          <div class="aircraft__text" v-if="day.plane.capacity">
                            {{ $t("common.capacity") }}: {{day.plane.capacity}}
                          </div>
                        </div>
                      </div>
                      <div class="aircraft__note" v-if="day.plane.isToiletAvailable === false">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11" cy="11" r="11" fill="#EB9514"/>
                            <g clip-path="url(#clip0_4381_45)">
                              <path d="M12.2572 14.5082H11.9429V9.729C11.9429 9.64757 11.9118 9.57688 11.8497 9.51713C11.7874 9.45756 11.7138 9.42773 11.6288 9.42773H9.74307C9.65794 9.42773 9.58431 9.45756 9.52207 9.51713C9.45984 9.5769 9.42871 9.64749 9.42871 9.729V10.3315C9.42871 10.4132 9.45982 10.4838 9.52207 10.5434C9.58421 10.6032 9.65784 10.633 9.74307 10.633H10.0573V14.5082H9.74307C9.65794 14.5082 9.58431 14.538 9.52207 14.5976C9.45984 14.6573 9.42871 14.7279 9.42871 14.8094V15.412C9.42871 15.4936 9.45982 15.5642 9.52207 15.6238C9.58421 15.6836 9.65784 15.7134 9.74307 15.7134H12.2572C12.3423 15.7134 12.416 15.6836 12.4782 15.6238C12.5403 15.5643 12.5716 15.4937 12.5716 15.412V14.8094C12.5716 14.728 12.5404 14.6573 12.4782 14.5976C12.416 14.5379 12.3423 14.5082 12.2572 14.5082Z" fill="white"/>
                              <path d="M10.9332 8.46999C11.5366 8.46999 12.0256 7.98089 12.0256 7.37757C12.0256 6.77425 11.5366 6.28516 10.9332 6.28516C10.3299 6.28516 9.84082 6.77425 9.84082 7.37757C9.84082 7.98089 10.3299 8.46999 10.9332 8.46999Z" fill="white"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_4381_45">
                                <rect x="6.28613" y="6.28516" width="9.42857" height="9.42857" fill="white"/>
                              </clipPath>
                            </defs>
                          </svg>
                        <span style="line-height: 22px">
                          {{ $t("common.noteNoToiletInAircraft") }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__participants"
                      v-if="day.type === 'FLIGHT'">
                    <div class="itinerary-day__participants-title">
                      <a>{{ $t("common.passengers") }}</a>
                      <i class="icon-arrow"></i>
                    </div>
                    <div class="itinerary-day__participants-content">
                      <template v-if="program.header.lang === 'RU'">
                        {{ showFormattedParticipants(day.participantNames) }}
                      </template>
                      <template v-else>{{
                          day.participantNames
                              .join(', ')
                              .replace('(Non-resident)', '')
                        }}</template>
                    </div>
                  </div>
                  <div
                      v-if="
                      (day.type === 'ARRIVAL' ||
                        day.type === 'DEPARTURE' ||
                        day.type === 'FLIGHT') &&
                      day.description
                    "
                      v-html="day.description"
                      class="itinerary-day__content"></div>
                  <!-- <span v-if="day.type === 'FLIGHT'" class="itinerary-day__top-duration"> <i class="icon-breafcase"></i>
                    <span class="wrap-val"><span>Luggage:</span>
                      <template v-for="(n, _ind) in day.participantNames">
                        <span class="itinerary-day__dark-text">{{n.split('(')[0]}}</span>
                        {{n.split('(')[1] != null ? '('+n.split('(')[1] : ''}}
                        {{_ind!==day.participantNames.length-1?',':''}}
                      </template>
                    </span>
                  </span> -->
                  <div class="itinerary-restrictions-info" v-if="day.importInfo">
                    <div class="itinerary-restrictions-info__title-wrapper">
                      <div>
                        <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.4981 5.85863H11.1415V1.75743C11.1415 0.788492 10.3532 0 9.38404 0H4.64866C3.67972 0 2.89114 0.788492 2.89114 1.75743V5.85855H1.53464C0.687151 5.85855 0 6.5457 0 7.39319V18.9801C0 19.828 0.687328 20.515 1.53464 20.515H1.74042V21.629C1.74042 21.8341 1.90661 22 2.11124 22H3.86619C4.07126 22 4.23718 21.8338 4.23718 21.629V20.515H9.79507V21.629C9.79507 21.8341 9.96143 22 10.1661 22H11.9208C12.1261 22 12.2918 21.8338 12.2918 21.629V20.515H12.4979C13.3454 20.515 14.0325 19.8278 14.0325 18.9801V7.39328C14.0327 6.54561 13.3455 5.85863 12.4981 5.85863ZM9.96958 5.85855H4.06258V1.75743C4.06258 1.43445 4.32541 1.17162 4.64839 1.17162H9.38377C9.70675 1.17162 9.96958 1.43445 9.96958 1.75743V5.85855Z" fill="#E85C20"/>
                          <path d="M7.0166 8C4.25965 8 2.0166 10.243 2.0166 13C2.0166 15.757 4.25965 18 7.0166 18C9.77355 18 12.0166 15.757 12.0166 13C12.0166 10.243 9.77355 8 7.0166 8ZM7.0166 16.75C4.94893 16.75 3.2666 15.0677 3.2666 13C3.2666 12.2108 3.50586 11.4648 3.96078 10.8282L9.18844 16.0558C8.55184 16.5107 7.80578 16.75 7.0166 16.75ZM10.0724 15.1718L4.84477 9.94418C5.48137 9.48926 6.22742 9.25 7.0166 9.25C9.08428 9.25 10.7666 10.9323 10.7666 13C10.7666 13.7892 10.5273 14.5352 10.0724 15.1718Z" fill="white"/>
                        </svg>
                      </div>
                      <div class="itinerary-restrictions-info__title">
                        {{ $t("common.prohibitedForImportIntoTanzania") }}
                      </div>
                    </div>
                    <div v-html="day.importInfo" class="itinerary-restrictions-info__html"></div>
                  </div>
                  <div class="itinerary-restrictions-info" v-if="day.exportInfo">
                    <div class="itinerary-restrictions-info__title-wrapper">
                      <div>
                        <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.4981 5.85863H11.1415V1.75743C11.1415 0.788492 10.3532 0 9.38404 0H4.64866C3.67972 0 2.89114 0.788492 2.89114 1.75743V5.85855H1.53464C0.687151 5.85855 0 6.5457 0 7.39319V18.9801C0 19.828 0.687328 20.515 1.53464 20.515H1.74042V21.629C1.74042 21.8341 1.90661 22 2.11124 22H3.86619C4.07126 22 4.23718 21.8338 4.23718 21.629V20.515H9.79507V21.629C9.79507 21.8341 9.96143 22 10.1661 22H11.9208C12.1261 22 12.2918 21.8338 12.2918 21.629V20.515H12.4979C13.3454 20.515 14.0325 19.8278 14.0325 18.9801V7.39328C14.0327 6.54561 13.3455 5.85863 12.4981 5.85863ZM9.96958 5.85855H4.06258V1.75743C4.06258 1.43445 4.32541 1.17162 4.64839 1.17162H9.38377C9.70675 1.17162 9.96958 1.43445 9.96958 1.75743V5.85855Z" fill="#E85C20"/>
                          <path d="M7.0166 8C4.25965 8 2.0166 10.243 2.0166 13C2.0166 15.757 4.25965 18 7.0166 18C9.77355 18 12.0166 15.757 12.0166 13C12.0166 10.243 9.77355 8 7.0166 8ZM7.0166 16.75C4.94893 16.75 3.2666 15.0677 3.2666 13C3.2666 12.2108 3.50586 11.4648 3.96078 10.8282L9.18844 16.0558C8.55184 16.5107 7.80578 16.75 7.0166 16.75ZM10.0724 15.1718L4.84477 9.94418C5.48137 9.48926 6.22742 9.25 7.0166 9.25C9.08428 9.25 10.7666 10.9323 10.7666 13C10.7666 13.7892 10.5273 14.5352 10.0724 15.1718Z" fill="white"/>
                        </svg>
                      </div>
                      <div class="itinerary-restrictions-info__title">{{ $t("common.prohibitedForExportFromTanzania") }}</div>
                    </div>
                    <div v-html="day.exportInfo" class="itinerary-restrictions-info__html"></div>
                  </div>
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      v-if="
                      (day.type === 'INFO' ||
                        day.type === 'REST_DAY' ||
                        day.type === 'OWN_ARRANGEMENTS') &&
                      (day.description || day.additionalNotes)
                    ">
                    <div class="itinerary-day__top-icon">
                      <i
                          v-if="
                          day.type === 'INFO' && !day.name.includes('COVID')
                        "
                          class="icon-info"></i>
                      <i
                          v-if="day.type === 'INFO' && day.name.includes('COVID')"
                          class="icon-info-none icon-covid">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none">
                          <path
                              d="M19.784 8.634c-.476 0-.887.419-1.087 1.028h-1.78a6.439 6.439 0 0 0-1.287-3.107l1.259-1.259c.572.29 1.159.295 1.495-.041.475-.475.27-1.451-.46-2.18-.728-.728-1.704-.934-2.179-.459-.336.336-.33.923-.041 1.495l-1.26 1.26a6.439 6.439 0 0 0-3.106-1.288v-1.78c.61-.2 1.028-.611 1.028-1.087C12.366.545 11.53 0 10.5 0 9.47 0 8.634.545 8.634 1.216c0 .476.419.887 1.028 1.087v1.78A6.438 6.438 0 0 0 6.555 5.37L5.296 4.111c.29-.572.295-1.159-.041-1.495-.475-.475-1.451-.27-2.18.46-.728.728-.934 1.704-.459 2.179.336.336.923.33 1.495.041l1.26 1.26a6.44 6.44 0 0 0-1.288 3.106h-1.78c-.2-.61-.611-1.028-1.087-1.028C.545 8.634 0 9.47 0 10.5c0 1.03.545 1.866 1.216 1.866.476 0 .887-.418 1.087-1.028h1.78a6.439 6.439 0 0 0 1.287 3.107l-1.259 1.259c-.572-.29-1.159-.295-1.495.041-.475.475-.27 1.451.46 2.18.728.728 1.704.934 2.179.459.336-.336.33-.923.041-1.495l1.26-1.26a6.438 6.438 0 0 0 3.106 1.289v1.78c-.61.2-1.028.61-1.028 1.086 0 .671.836 1.216 1.866 1.216 1.03 0 1.866-.545 1.866-1.216 0-.476-.418-.887-1.028-1.087v-1.78a6.438 6.438 0 0 0 3.107-1.287l1.259 1.259c-.29.572-.295 1.159.041 1.495.475.475 1.451.27 2.18-.46.728-.728.934-1.704.459-2.179-.336-.336-.923-.33-1.495-.041l-1.259-1.26a6.44 6.44 0 0 0 1.287-3.106h1.78c.2.61.611 1.028 1.087 1.028.672 0 1.216-.836 1.216-1.866 0-1.03-.544-1.866-1.216-1.866Z"
                              fill="#fff" />
                          <path
                              d="M8.646 16.701C6.53 15.14 5.164 12.685 5.164 9.923c0-1.68.505-3.246 1.378-4.567L5.296 4.111c.29-.572.295-1.159-.041-1.495-.475-.475-1.45-.27-2.18.46-.728.728-.934 1.704-.459 2.179.336.336.923.33 1.495.041l1.26 1.26a6.439 6.439 0 0 0-1.288 3.106h-1.78c-.2-.61-.611-1.028-1.087-1.028C.545 8.634 0 9.47 0 10.5c0 1.03.545 1.866 1.216 1.866.476 0 .887-.419 1.087-1.028h1.78a6.438 6.438 0 0 0 1.287 3.107l-1.259 1.259c-.572-.29-1.159-.295-1.495.041-.475.475-.27 1.451.46 2.18.728.728 1.704.934 2.179.459.336-.336.33-.923.041-1.495l1.26-1.26a6.453 6.453 0 0 0 2.09 1.072Z"
                              fill="#fff" />
                          <path
                              d="M7.004 9.791c0-1.147.448-2.205 1.202-3.053l-.03-.006a1.196 1.196 0 0 0-1.444 1.444v.001a1.196 1.196 0 0 1-.54 1.302 1.196 1.196 0 0 0 0 2.042c.444.27.662.797.54 1.302v.002c-.21.87.574 1.654 1.443 1.443h.002a1.196 1.196 0 0 1 1.302.54 1.196 1.196 0 0 0 2.042 0c.02-.033.041-.064.064-.094-2.624-.515-4.58-2.524-4.58-4.923Z"
                              fill="#fff" />
                        </svg>
                      </i>

                      <i
                          v-if="day.type === 'OWN_ARRANGEMENTS'"
                          class="icon-info icon-info-none">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0)">
                            <path
                                d="M13.1807 17.6172H4.93848C4.19418 17.6172 3.59082 18.2205 3.59082 18.9648V19.375C3.59082 19.4829 3.67828 19.5703 3.78613 19.5703H14.333C14.4409 19.5703 14.5283 19.4829 14.5283 19.375V18.9648C14.5283 18.2205 13.9249 17.6172 13.1807 17.6172Z"
                                fill="white" />
                            <path
                                d="M5.54395 16.5625V17.2266H12.5752V16.5625C12.5752 15.8506 11.998 15.2734 11.2861 15.2734H6.83301C6.12105 15.2734 5.54395 15.8506 5.54395 16.5625Z"
                                fill="white" />
                            <path
                                d="M10.0361 1.40625C10.0361 0.866914 9.5989 0.429688 9.05957 0.429688C8.52023 0.429688 8.08301 0.866914 8.08301 1.40625V14.8828H10.0361V1.40625Z"
                                fill="white" />
                            <path
                                d="M7.69239 4.92188H2.41895L-0.112536 6.73008C-0.21574 6.80379 -0.222419 6.95477 -0.12613 7.0373L2.41895 9.21875H7.69239V4.92188Z"
                                fill="white" />
                            <path
                                d="M10.4268 7.46094V11.7578H15.5816L18.1131 9.94965C18.2163 9.87594 18.223 9.72496 18.1267 9.64242L15.5816 7.46094H10.4268Z"
                                fill="white" />
                            <path
                                d="M18.1267 4.95492L15.5816 2.77344H10.4268V7.07031H15.5816L18.1131 5.26215C18.2163 5.18844 18.223 5.03746 18.1267 4.95492Z"
                                fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </i>
                      <i
                          v-if="day.type === 'REST_DAY'"
                          class="icon-info icon-info-none">
                        <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0)">
                            <path
                                d="M15.6226 13.5693H11.1104V7.60685H13.0229C13.0012 5.98006 12.6961 4.32455 12.1779 3.03754C11.7001 1.8506 11.0777 1.11328 10.5538 1.11328C10.0298 1.11328 9.40752 1.8506 8.92967 3.03754C8.41155 4.32452 8.10641 5.98006 8.0847 7.60685H9.99715V13.5693H6.41939L4.78533 11.9353C3.61405 10.764 1.70832 10.764 0.537081 11.9353C0.432693 12.0397 0.374023 12.1813 0.374023 12.3289C0.374023 12.4765 0.432693 12.6181 0.537081 12.7224L4.55896 16.7443C4.55054 16.7654 4.5429 16.787 4.53692 16.8095L4.14286 18.301C4.06434 18.5982 4.24164 18.9029 4.53885 18.9814C4.5865 18.994 4.63433 19 4.68139 19C4.9279 19 5.15327 18.8349 5.21921 18.5854L5.60373 17.1299H16.3561V18.4432C16.3561 18.7506 16.6053 18.9999 16.9127 18.9999C17.2201 18.9999 17.4694 18.7506 17.4694 18.4432V17.1299H18.0699C18.3773 17.1299 18.6266 16.8807 18.6266 16.5733C18.6266 14.9169 17.279 13.5693 15.6226 13.5693Z"
                                fill="white" />
                            <path
                                d="M13.2105 2.62176C13.7796 4.03528 14.1142 5.84223 14.1362 7.60684H17.0473C17.3547 7.60684 17.6039 7.35762 17.6039 7.05021C17.6039 3.16273 14.4412 0 10.5537 0C11.5863 0 12.5299 0.931104 13.2105 2.62176Z"
                                fill="white" />
                            <path
                                d="M7.89729 2.62176C8.57798 0.931104 9.52152 0 10.5542 0C6.6666 0 3.50391 3.16273 3.50391 7.05021C3.50391 7.35762 3.75313 7.60684 4.06054 7.60684H6.97164C6.99368 5.84227 7.32822 4.03532 7.89729 2.62176Z"
                                fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="19" height="19" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>{{ day.name }}</h3>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__content"
                      v-if="
                      (day.type === 'INFO' ||
                        day.type === 'REST_DAY' ||
                        day.type === 'OWN_ARRANGEMENTS') &&
                      day.description
                    "
                      v-html="day.description"></div>
                  <!--ISLAND NEW TYPE start-->
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      v-if="day.type === 'ISLAND'">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-palm">
                        <svg
                            :style="{marginLeft: '2px'}"
                            width="21px"
                            height="21px"
                            class="icon-newmoon icon-grey">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-palm"></use>
                        </svg>
                      </i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.beachVacation") }}</span>
                        {{ day.name }}
                      </h3>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__content"
                      v-if="day.type === 'ISLAND'">
                    <div v-if="day.photoId" class="itinerary-day__img">
                      <a
                          :data-src="`${API}/documents/share/images/${day.photoId}?size=MEDIUM`">
                        <img
                            :src="`${API}/documents/share/images/${day.photoId}?size=MEDIUM`"
                            class="js-lazy"
                            alt="" />
                        <!-- <div class="zoom">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.4888 14.5735L11.6808 10.6129C12.6599 9.44901 13.1964 7.98455 13.1964 6.45999C13.1964 2.89801 10.2983 0 6.73636 0C3.17438 0 0.276367 2.89801 0.276367 6.45999C0.276367 10.022 3.17438 12.92 6.73636 12.92C8.07358 12.92 9.34788 12.5167 10.4374 11.751L14.2743 15.7416C14.4347 15.9082 14.6504 16 14.8816 16C15.1004 16 15.3079 15.9166 15.4655 15.7649C15.8003 15.4428 15.811 14.9085 15.4888 14.5735ZM6.73636 1.68522C9.36923 1.68522 11.5111 3.82713 11.5111 6.45999C11.5111 9.09286 9.36923 11.2348 6.73636 11.2348C4.10349 11.2348 1.96158 9.09286 1.96158 6.45999C1.96158 3.82713 4.10349 1.68522 6.73636 1.68522Z" fill="white"/>
                          </svg>
                        </div> -->
                      </a>
                    </div>
                    <p v-if="day.description" v-html="day.description"></p>
                    <div v-if="item.notes" class="notes">
                      <template v-if="item.notes.length > 0">
                        <div class="notes__title">
                          <img src="/images/notes-yellow-icon.svg" alt="" />
                          <b>{{ $t("common.notes") }}:</b>
                        </div>
                        <div v-html="item.notes" class="notes__body"></div>
                      </template>
                    </div>
                  </div>

                  <!--ISLAND NEW TYPE end-->

                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      v-if="day.type === 'ACCOMMODATION'">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-bed"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.accommodation") }}</span>
                        {{ day.name }}
                        <div class="rating hotel-rating">
                          <div
                              class=""
                              v-if="day.ratio === '0' || day.ratio === 0"></div>
                          <div
                              class=""
                              v-if="day.ratio === '0.5' || day.ratio === 0.5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="6"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="-6"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '1' || day.ratio === 1">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '1.5' || day.ratio === 1.5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="6"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="-6"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '2' || day.ratio === 2">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '2.5' || day.ratio === 2.5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="6"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="-6"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '3' || day.ratio === 3">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '3.5' || day.ratio === 3.5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="6"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="-6"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '4' || day.ratio === 4">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '4.5' || day.ratio === 4.5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="6"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="-6"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                          <div
                              class=""
                              v-if="day.ratio === '5' || day.ratio === 5">
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                              <mask
                                  id="mask0_1774_10"
                                  style="mask-type: alpha"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="32"
                                  height="32">
                                <path
                                    d="M11.4699 4.59639L8.92953 7.07275L9.52945 10.5703C9.55555 10.7233 9.49275 10.8778 9.36713 10.9692C9.29617 11.021 9.21175 11.0471 9.12733 11.0471C9.06248 11.0471 8.99723 11.0316 8.93769 11.0002L5.79655 9.34887L2.65583 10.9998C2.5188 11.0724 2.35199 11.0605 2.22638 10.9688C2.10077 10.8774 2.03796 10.7229 2.06406 10.5699L2.66399 7.07234L0.123185 4.59639C0.0122544 4.4879 -0.0281211 4.32558 0.0200032 4.17836C0.0681275 4.03113 0.195779 3.92305 0.349533 3.90062L3.86057 3.39083L5.43073 0.208913C5.56817 -0.0696376 6.02494 -0.0696376 6.16238 0.208913L7.73254 3.39083L11.2436 3.90062C11.3973 3.92305 11.525 4.03072 11.5731 4.17836C11.6212 4.32599 11.5809 4.48749 11.4699 4.59639Z"
                                    fill="#EB9514" />
                              </mask>
                              <g mask="url(#mask0_1774_10)">
                                <rect
                                    x="12"
                                    width="12"
                                    height="12"
                                    fill="#CCCCCC" />
                                <rect
                                    x="0"
                                    width="12"
                                    height="12"
                                    fill="#EB9514" />
                              </g>
                            </svg>
                          </div>
                        </div>
                      </h3>

                      <div
                          v-if="day.hotelInfo.type === 'ECO_LODGES'"
                          class="itinerary-day__top-hotel-type">
                        <span :style="{marginRight: '6px'}">
                          <svg width="31" height="20" class="icon-eco-title">
                            <use
                                xlink:href="/images/useful/sprites/sprite.svg#eco-lodge"></use>
                          </svg>
                        </span>
                        <span>Eco lodge</span>
                        <!--                        <span class="itinerary-day__top-hotel-type-content">Eco Lodge blah blah transfers through Ngorongoro will be calculated</span>-->
                      </div>

                      <span v-if="false" class="itinerary-day__top-upgrade">
                        <i class="icon-diamond"></i>
                        Upgrade hotel
                      </span>
                    </div>
                  </div>

                  <div class="itinerary-day__content" v-if="day.type === 'ACCOMMODATION'">
                    <div class="itinerary__booked-by-guest-alert-wrapper" v-if="day.bookedByGuest === true">
                      <div class="itinerary__booked-by-guest-alert-icon">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.7166 17.462L12.6925 2.49637C12.337 1.90679 11.6885 1.54053 11 1.54053C10.3115 1.54053 9.66296 1.90679 9.30739 2.49641L0.283398 17.462C-0.0840279 18.0714 -0.094899 18.8349 0.254996 19.4545C0.604976 20.0741 1.26437 20.459 1.97594 20.459H20.024C20.7356 20.459 21.395 20.0741 21.745 19.4545C22.0949 18.8348 22.084 18.0713 21.7166 17.462ZM20.4978 18.7502C20.4015 18.9207 20.2199 19.0267 20.024 19.0267H1.97594C1.78004 19.0267 1.5985 18.9207 1.50221 18.7502C1.40587 18.5796 1.40888 18.3694 1.50998 18.2017L10.5341 3.23603C10.6319 3.07374 10.8105 2.97289 11 2.97289C11.1895 2.97289 11.368 3.07374 11.4659 3.23603L20.4899 18.2017C20.5911 18.3695 20.5941 18.5796 20.4978 18.7502Z" fill="#EB9514"/>
                          <path d="M11.0062 7.43408C10.4614 7.43408 10.0361 7.72644 10.0361 8.24473C10.0361 9.82607 10.2221 12.0984 10.2221 13.6798C10.2222 14.0917 10.581 14.2645 11.0062 14.2645C11.3252 14.2645 11.777 14.0917 11.777 13.6798C11.777 12.0985 11.963 9.82611 11.963 8.24473C11.963 7.72648 11.5245 7.43408 11.0062 7.43408Z" fill="#EB9514"/>
                          <path d="M11.0203 15.1812C10.4357 15.1812 9.99707 15.6462 9.99707 16.2044C9.99707 16.7493 10.4356 17.2277 11.0203 17.2277C11.5652 17.2277 12.0303 16.7493 12.0303 16.2044C12.0303 15.6462 11.5651 15.1812 11.0203 15.1812Z" fill="#EB9514"/>
                        </svg>

                      </div>
                      <div class="itinerary__booked-by-guest-alert-text">
                        {{ $t("common.hotelBookedByGuest") }}
                      </div>
                    </div>
                    <div class="itinerary__alert-not-booked" v-if="isShowHotelNotBookedAlert(program.header.status)">
                      {{ $t("common.hotelsNotBookedYet") }}
                    </div>
                    <div
                        class="itinerary-day__imgs"
                        v-if="
                        day.hotelInfo &&
                        day.hotelInfo.photos &&
                        day.hotelInfo.photos.length > 0
                      ">
                      <a
                          v-for="photo in day.hotelInfo.photos"
                          :key="photo"
                          :data-src="`${API}/documents/share/images/${photo}?size=MEDIUM`">
                        <img
                            :src="`${API}/documents/share/images/${photo}?size=MEDIUM`"
                            class="js-lazy"
                            alt="" />
                        <div
                            class="zoom"
                            @click="zoomImage(day.hotelInfo.photos, photo)"
                            style="cursor: pointer">
                          <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.4888 14.5735L11.6808 10.6129C12.6599 9.44901 13.1964 7.98455 13.1964 6.45999C13.1964 2.89801 10.2983 0 6.73636 0C3.17438 0 0.276367 2.89801 0.276367 6.45999C0.276367 10.022 3.17438 12.92 6.73636 12.92C8.07358 12.92 9.34788 12.5167 10.4374 11.751L14.2743 15.7416C14.4347 15.9082 14.6504 16 14.8816 16C15.1004 16 15.3079 15.9166 15.4655 15.7649C15.8003 15.4428 15.811 14.9085 15.4888 14.5735ZM6.73636 1.68522C9.36923 1.68522 11.5111 3.82713 11.5111 6.45999C11.5111 9.09286 9.36923 11.2348 6.73636 11.2348C4.10349 11.2348 1.96158 9.09286 1.96158 6.45999C1.96158 3.82713 4.10349 1.68522 6.73636 1.68522Z"
                                fill="white" />
                          </svg>
                        </div>
                      </a>
                    </div>
                    <div v-if="day.hotelInfo.videoReviewUrl" class="videoReview" @click="isModalVideoReview = true; modalVideoReviewURL = day.hotelInfo.videoReviewUrl">
                      <div class="videoReview_icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"><path stroke-linecap="round" d="M2.45 11.419c0-3.017.3-4.526 1.237-5.463s2.446-.937 5.463-.937h5.7c3.017 0 4.525 0 5.463.937s1.237 2.446 1.237 5.463v1.162c0 3.017-.3 4.526-1.237 5.463s-2.446.937-5.463.937h-5.7c-3.017 0-4.526 0-5.463-.937S2.45 15.598 2.45 12.581z"/><path d="m14.686 11.491l-4.268-2.667a.6.6 0 0 0-.918.509v5.335a.6.6 0 0 0 .918.508l4.268-2.667a.6.6 0 0 0 0-1.018Z"/></g></svg></div>
                      <div>{{ $t("common.videoReview") }}</div>
                    </div>
                    <div class="itinerary-day__rooming active">
                      <span class="itinerary-day__rooming-title">
                        <i class="icon-bed3"></i>
                        <a>{{ $t("common.accommodationDetails") }}</a>
                        <i class="icon-arrow"></i>
                      </span>
                      <ul class="itinerary-day__rooming-content">
                        <li
                            class="itinerary-day__rooming-item"
                            v-for="(room, _ind) in day.hotelInfo.rooms"
                            :key="`${room.roomId}_${Math.random()}`">
                          <div class="itinerary-day__rooming-item-title">
                            <span class="itinerary-day__rooming-item-num">{{
                                _ind + 1
                              }}</span>
                            {{ room.roomName }}
                          </div>
                          <div style="padding-left: 30px">
                            <HotelCheckInOutTimeLabel textColor="#404040" :earlyCheckIn="room.earlyCheckIn" :lateCheckOut="room.lateCheckOut" />
                          </div>
                          <div class="itinerary-day__rooming-item-box">
                            <span class="itinerary-day__rooming-item-names">{{
                                room.participantNames
                                    .join(', ')
                                    .replace('(Non-resident)', '')
                              }}</span>
                            <span
                                class="itinerary-day__rooming-item-meal itinerary-day__basis"
                                v-if="room.mealDescription">
                              <span style="display: inline-block"
                              ><i
                                  class="icon-chocolate"
                                  style="margin-right: 0px"></i>
                                {{ $t("common.mealPlan") }}:</span
                              >
                              {{ room.mealDescription }}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="itinerary-shared-accommodation" v-if="day.hotelInfo.oneBedInTwin">
                      <div class="itinerary-shared-accommodation__info-wrapper">
                        <div class="itinerary-shared-accommodation__image">
                          <img src="/images/itinerary/iti_twin_man.png" alt="Upgrade accommodation">
                        </div>
                        <div class="itinerary-shared-accommodation__text-wrapper">
                          <div class="itinerary-shared-accommodation__title">
                            {{ $t("common.sharedAccommodation") }}
                          </div>
                          <div class="itinerary-shared-accommodation__text">
                            {{ $t("itinerary.standardClimbingIncludes") }}
                          </div>
                        </div>
                      </div>
                      <div class="itinerary-shared-accommodation__cta-wrapper">
                        <div class="itinerary-shared-accommodation__alert">
                          <span>⚠️</span>
                          {{ $t("common.singleRoomAvailableFor") }}
                          {{
                            getCurrencySign(program.header.currency)
                          }}{{day.hotelInfo.oneBedInTwin.price}}!
                        </div>
                        <div class="itinerary-shared-accommodation__button" @click="
                        isModalUpgradeAccommodation = true;
                        upgradeAccommodationData.programId = day.hotelInfo.oneBedInTwin.programId;
                        upgradeAccommodationData.price = day.hotelInfo.oneBedInTwin.price;
                        ">
                          {{ $t("common.upgradeToSingleRoom") }}
                        </div>
                      </div>
                    </div>
                    <p v-html="day.hotelInfo.description"></p>
                    <ul class="itinerary-day__add">
                      <li
                          v-for="amen in day.hotelInfo.amenities"
                          :class="amen.color === 'red' ? 'red' : 'green'"
                          :key="amen.type">
                        <i
                            v-if="amen.type.toLowerCase() !== 'restaurant'"
                            :class="`icon-${amen.type.toLowerCase()}`"></i>
                        <span
                            v-if="amen.type.toLowerCase() === 'restaurant' ||
                             amen.type.toLowerCase() === 'no_air_conditioner' ||
                             amen.type.toLowerCase() === 'public_area_wifi' ||
                             amen.type.toLowerCase() === 'public_area_charges' ||
                             amen.type.toLowerCase() === 'fan_in_room' ||
                             amen.type.toLowerCase() === 'hair_dryer_available' ||
                             amen.type.toLowerCase() === 'mosquito_nets' ||
                             amen.type.toLowerCase() === 'no_hair_dryer' ||
                             amen.type.toLowerCase() === 'bucket_shower' ||
                             amen.type.toLowerCase() === 'limited_electricity'"
                            style="padding-right: 5px">
                          <svg
                              width="1em"
                              height="1em"
                              :class="'icon icon-' + amen.type.toLowerCase()">
                            <use
                                :xlink:href="
                                '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                amen.type.toLowerCase()
                              "></use>
                          </svg>
                        </span>
                        {{ amen.name }}
                        <span v-if="amen.tooltip !== null" class="mmt-tooltip" style="margin-left: 10px">
                              <img v-if="amen.color === 'green'" v-tooltip="{content: amen.tooltip, offset: 5}" src="/images/useful/svg/help-icon.svg" alt=""/>
                              <img v-if="amen.color === 'red'" v-tooltip="{content: amen.tooltip, offset: 5}" src="/images/useful/svg/question-red.svg" alt=""/>
                          </span>
                      </li>
                    </ul>
                  </div>
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      v-if="day.type === 'CLIMBING'">
                    <div class="itinerary-day__top-icon">
                      <i
                          :class="
                          'icon-' +
                          (item.dayInfo[idx - 1] &&
                          (item.dayInfo[idx - 1].name.includes('Summit') ||
                            item.dayInfo[idx - 1].name.includes('штурм'))
                            ? 'finish'
                            : 'mountain')
                        "></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span
                            class="itinerary-day__top-type"
                            v-if="program.header.lang !== 'RU'"
                        >{{ $t("common.expeditionDay") }}
                          {{ day.day }}</span
                        >
                        <span
                            class="itinerary-day__top-type"
                            v-if="program.header.lang === 'RU'"
                        >{{
                            day.day === 1
                                ? 'Первый'
                                : day.day === 2
                                    ? 'Второй'
                                    : day.day === 3
                                        ? 'Третий'
                                        : day.day === 4
                                            ? 'Четвертый'
                                            : day.day === 5
                                                ? 'Пятый'
                                                : day.day === 6
                                                    ? 'Шестой'
                                                    : day.day === 7
                                                        ? 'Седьмой'
                                                        : day.day === 8
                                                            ? 'Восьмой'
                                                            : day.day === 9
                                                                ? 'Девятый'
                                                                : day.day === 10
                                                                    ? 'Десятый'
                                                                    : day.day === 11
                                                                        ? 'Одинадцатый'
                                                                        : day.day === 12
                                                                            ? 'Двенадцатый'
                                                                            : day.day === 13
                                                                                ? 'Тринадцатый'
                                                                                : day.day === 14
                                                                                    ? 'Четырнадцатый'
                                                                                    : day.day === 15
                                                                                        ? 'Пятнадцатый'
                                                                                        : ''
                          }}
                          день экспедиции</span
                        >
                        {{ day.name }}
                      </h3>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__content"
                      v-if="day.type === 'CLIMBING'">
                    <div class="itinerary-day__img">
                      <a
                          v-for="photo in day.photos"
                          :key="photo"
                          :data-src="`${API}/documents/share/images/${photo}?size=MEDIUM`">
                        <img
                            :src="`${API}/documents/share/images/${photo}?size=MEDIUM`"
                            class="js-lazy"
                            alt="" />
                        <!-- <div class="zoom">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.4888 14.5735L11.6808 10.6129C12.6599 9.44901 13.1964 7.98455 13.1964 6.45999C13.1964 2.89801 10.2983 0 6.73636 0C3.17438 0 0.276367 2.89801 0.276367 6.45999C0.276367 10.022 3.17438 12.92 6.73636 12.92C8.07358 12.92 9.34788 12.5167 10.4374 11.751L14.2743 15.7416C14.4347 15.9082 14.6504 16 14.8816 16C15.1004 16 15.3079 15.9166 15.4655 15.7649C15.8003 15.4428 15.811 14.9085 15.4888 14.5735ZM6.73636 1.68522C9.36923 1.68522 11.5111 3.82713 11.5111 6.45999C11.5111 9.09286 9.36923 11.2348 6.73636 11.2348C4.10349 11.2348 1.96158 9.09286 1.96158 6.45999C1.96158 3.82713 4.10349 1.68522 6.73636 1.68522Z" fill="white"/>
                          </svg>
                        </div> -->
                      </a>
                    </div>
                    <p v-if="day.description" v-html="day.description"></p>
                    <div
                        class="itinerary-day__info"
                        v-if="day.additionalNotes"
                        v-html="day.additionalNotes"></div>
                    <div v-if="day.portableToiletSuggestion">
                      <div class="itinerary-day__banner">
                        <div class="banner__image">
                          <div class="image">
                            <img src="/images/portable-toilet.png" alt="portable toilet banner">
                            <div class="price-v2">
                              ${{day.portableToiletSuggestion.price}}
                            </div>
                          </div>

                        </div>
                        <div class="banner__title">
                          <span>{{ $t("common.addPortableToilet") }}</span>
                        </div>
                        <div class="banner__offer">
                          <div class="banner__offer-text">
                            {{ $t("itinerary.climbWithHighestComfort", {price: day.portableToiletSuggestion.price}) }}
                          </div>
                          <button
                              @click="isModalSendPortableToilet = true, portableToiletOptions.clientId = day.portableToiletSuggestion.clientId"
                              class="btn btn--green"
                              :disabled="day.portableToiletSuggestion.requested || isModalPortableToiletSendResult"
                          >
                            <span>{{ $t("common.inquireNow") }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <span class="itinerary-day__change">
                      <span
                      >{{ $t("common.elevationChange") }}:
                      </span>
                      {{ day.info.from.name }} ({{ day.info.from.height }} m/{{
                        (day.info.from.height * 3.28084).toFixed()
                      }}
                      ft) <i class="icon-arrow2"></i>
                      {{
                        day.info.peak
                            ? `${day.info.peak.name} (${
                                day.info.peak.height
                            } m/${(
                                day.info.peak.height * 3.28084
                            ).toFixed()} ft)`
                            : ''
                      }}
                      <i v-if="day.info.peak" class="icon-arrow2"></i>
                      {{ day.info.to.name }} ({{ day.info.to.height }} m/{{
                        (day.info.to.height * 3.28084).toFixed()
                      }}
                      ft)
                    </span>
                    <ul class="itinerary-day__features">
                      <li>
                        <i class="icon-ruler"></i
                        ><span
                      >{{ $t("common.distance") }}: </span
                      >{{ day.info.distance }}
                        {{ $t("common.kilometersShort") }}
                      </li>
                      <li>
                        <i class="icon-sun"></i
                        ><span>{{ $t("common.averageDayTemp") }}: </span>{{ day.info.temperature.day }}
                        °C
                      </li>
                      <li>
                        <i class="icon-half-moon"></i>
                        <span
                        >{{ $t("common.moonPhase") }}: </span
                        >{{ day.info.moonPhaseDescription }}
                        <svg
                            :style="{marginLeft: '6px'}"
                            width="1em"
                            height="1em"
                            class="icon icon-newmoon icon-grey"
                            v-if="day.info.moonPhaseType === 'NEW_MOON'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-newmoon"></use>
                        </svg>
                        <svg
                            :style="{marginLeft: '6px'}"
                            width="1em"
                            height="1em"
                            class="icon icon-firstquater icon-grey"
                            v-if="day.info.moonPhaseType === '1ST_QUATER'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-firstquater"></use>
                        </svg>
                        <svg
                            :style="{marginLeft: '6px'}"
                            width="1em"
                            height="1em"
                            class="icon icon-fullmoon icon-grey"
                            v-if="day.info.moonPhaseType === 'FULL_MOON'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fullmoon"></use>
                        </svg>
                        <svg
                            :style="{marginLeft: '6px'}"
                            width="1em"
                            height="1em"
                            class="icon icon-thirdquater icon-grey"
                            v-if="day.info.moonPhaseType === '3RD_QUATER'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-thirdquater"></use>
                        </svg>
                      </li>
                      <li>
                        <i class="icon-clock"></i><span>{{ $t("common.trekkingTime") }}: </span
                      >
                        {{ getTimeFromMins(day.info.time, program.header.lang) }}
                      </li>
                      <li>
                        <i class="icon-cloudy-night"></i
                        ><span
                      >{{ $t("common.averageNightTemp") }}: </span
                      >{{ day.info.temperature.night }}
                        °C
                      </li>
                    </ul>
                    <div class="premium-option__wrapper" v-if="day.day === 1">
                      <div class="premium-option__first-part">
                        <div class="premium-option__info-block">
                          <h2 class="premium-option__title">
                            {{ $t("common.professionalGuides") }}
                          </h2>
                          <p class="premium-option__title-secondary">
                            {{ $t("itinerary.bestGuidesText") }}
                            <a :href="program.header.lang !== 'RU'
                                  ? `https://altezza.travel/${program.header.lang.toLowerCase()}/kilimanjaro-guides-and-porters`
                                  : 'https://altezza.travel/kilimanjaro-guides-and-porters'" target="_blank"
                               class="premium-option__read-more">{{ $t("common.readMore") }}</a>
                          </p>
                        </div>
                      </div>
                      <div class="premium-option__second-part">
                        <div class="premium-option__image-wrapper">
                          <img src="/images/itinerary/promo-2.png" alt="">
                        </div>
                        <div class="premium-option__text premium-option__text--double">
                          <div>
                            <div class="premium-option__text--double-title-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22"
                                   fill="none">
                                <path
                                    d="M12.4233 0H3.65391C1.63622 0 0 1.63622 0 3.65391V16.0772C0 18.0949 1.63622 19.7311 3.65391 19.7311H11.6925V17.4576C10.79 16.5347 10.2309 15.2741 10.2309 13.8849C10.2309 11.064 12.5263 8.76938 15.3464 8.76938C15.5949 8.76938 15.8375 8.7935 16.0772 8.82784V3.65391C16.0772 1.63622 14.441 0 12.4233 0ZM7.43936 16.0772H3.65391C3.24979 16.0772 2.92313 15.7498 2.92313 15.3464C2.92313 14.943 3.24979 14.6156 3.65391 14.6156H7.43936C7.84348 14.6156 8.17014 14.943 8.17014 15.3464C8.17014 15.7498 7.84348 16.0772 7.43936 16.0772ZM7.61475 12.4233H3.65391C3.24979 12.4233 2.92313 12.0959 2.92313 11.6925C2.92313 11.2891 3.24979 10.9617 3.65391 10.9617H7.61475C8.01887 10.9617 8.34553 11.2891 8.34553 11.6925C8.34553 12.0959 8.01887 12.4233 7.61475 12.4233ZM9.82901 8.76938H3.65391C3.24979 8.76938 2.92313 8.44199 2.92313 8.0386C2.92313 7.63521 3.24979 7.30782 3.65391 7.30782H9.82901C10.2331 7.30782 10.5598 7.63521 10.5598 8.0386C10.5598 8.44199 10.2331 8.76938 9.82901 8.76938ZM12.4233 5.11547H3.65391C3.24979 5.11547 2.92313 4.78808 2.92313 4.38469C2.92313 3.9813 3.24979 3.65391 3.65391 3.65391H12.4233C12.8274 3.65391 13.1541 3.9813 13.1541 4.38469C13.1541 4.78808 12.8274 5.11547 12.4233 5.11547Z"
                                    fill="#3E3E3E"/>
                                <path
                                    d="M15.3466 19.0001C14.5611 19.0001 13.8193 18.8174 13.1543 18.501V21.191C13.1543 21.7749 13.8047 22.1227 14.2907 21.799L15.3466 21.0945L16.4026 21.799C16.8886 22.1227 17.539 21.7749 17.539 21.191V18.501C16.874 18.8174 16.1322 19.0001 15.3466 19.0001Z"
                                    fill="#3E3E3E"/>
                                <path
                                    d="M15.3453 17.5393C17.3633 17.5393 18.9992 15.9034 18.9992 13.8854C18.9992 11.8674 17.3633 10.2314 15.3453 10.2314C13.3273 10.2314 11.6914 11.8674 11.6914 13.8854C11.6914 15.9034 13.3273 17.5393 15.3453 17.5393Z"
                                    fill="#3E3E3E"/>
                              </svg>
                              <span class="premium-option__text--double__title">{{ $t("itinerary.sevenYearsOfExperience") }}</span></div>
                            {{ $t("itinerary.sevenYearsOfExperienceText") }}
                          </div>
                          <div>
                            <div class="premium-option__text--double-title-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                   fill="none">
                                <path
                                    d="M11.479 7.94721V4.88086H8.55835V7.94721C8.55835 8.2707 8.29609 8.53296 7.9726 8.53296H4.90625V11.4536H7.9726C8.29609 11.4536 8.55835 11.7159 8.55835 12.0394V15.1057H11.479V12.0394C11.479 11.7159 11.7413 11.4536 12.0648 11.4536H15.1311V8.53296H12.0648C11.7413 8.53296 11.479 8.2707 11.479 7.94721Z"
                                    fill="#3E3E3E"/>
                                <path
                                    d="M17.0711 2.92893C15.1823 1.04018 12.6711 0 10 0C7.32892 0 4.81767 1.04018 2.92893 2.92893C1.04018 4.81767 0 7.32892 0 10C0 12.6711 1.04018 15.1823 2.92893 17.0711C4.81767 18.9598 7.32888 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32892 18.9598 4.81767 17.0711 2.92893ZM16.3021 12.0392C16.3021 12.3627 16.0398 12.625 15.7163 12.625H12.65V15.6913C12.65 16.0148 12.3877 16.2771 12.0642 16.2771H7.97204C7.64855 16.2771 7.38628 16.0148 7.38628 15.6913V12.625H4.31994C3.99645 12.625 3.73418 12.3627 3.73418 12.0392V7.94709C3.73418 7.62359 3.99645 7.36133 4.31994 7.36133H7.38628V4.29498C7.38628 3.97149 7.64855 3.70923 7.97204 3.70923H12.0642C12.3877 3.70923 12.65 3.97149 12.65 4.29498V7.36133H15.7163C16.0398 7.36133 16.3021 7.62359 16.3021 7.94709V12.0392Z"
                                    fill="#3E3E3E"/>
                              </svg>
                              <span class="premium-option__text--double__title">{{ $t("itinerary.WFRCertificates") }}</span>
                            </div>
                            {{ $t("itinerary.WFRCertificatesText") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="premium-option__wrapper" v-if="day.day === 2">
                      <div class="premium-option__first-part">
                        <div class="premium-option__info-block">
                          <h2 class="premium-option__title">
                            {{ $t("itinerary.KPAPOperator") }}
                          </h2>
                          <p class="premium-option__title-secondary">
                            {{ $t("itinerary.KPAPOperatorText") }}
                            <a :href="program.header.lang === 'EN'
                                  ? `https://altezza.travel/en/about-us#kpap`
                                  : program.header.lang === 'RU' ? 'https://altezza.travel/about-us#kpap'
                                  : 'https://altezza.travel/de/articles/about-kpap'" target="_blank"
                               class="premium-option__read-more">{{ $t("common.readMore") }}</a>
                          </p>
                        </div>
                      </div>
                      <div class="premium-option__second-part">
                        <div class="premium-option__image-wrapper">
                          <img src="/images/itinerary/promo-1.png" alt="">
                        </div>
                        <p class="premium-option__text" >
                          {{ $t("itinerary.KPAPDescriptionText") }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <template v-if="day.type === 'SAFARI_PARK'">
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-pawprint"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                          <span class="itinerary-day__top-type">{{ $t("common.safari") }}</span>
                          {{ day.name }}
                        </h3>
                      </div>
                    </div>
                    <div class="itinerary-day__content">
                      <div v-if="day.photos.length" class="itinerary-day__img">
                        <a
                            v-for="photo in day.photos"
                            :key="photo"
                            :data-src="`${API}/documents/share/images/${photo}?size=MEDIUM`">
                          <img
                              :src="`${API}/documents/share/images/${photo}?size=MEDIUM`"
                              class="js-lazy"
                              alt="" />
                          <!-- <div class="zoom">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.4888 14.5735L11.6808 10.6129C12.6599 9.44901 13.1964 7.98455 13.1964 6.45999C13.1964 2.89801 10.2983 0 6.73636 0C3.17438 0 0.276367 2.89801 0.276367 6.45999C0.276367 10.022 3.17438 12.92 6.73636 12.92C8.07358 12.92 9.34788 12.5167 10.4374 11.751L14.2743 15.7416C14.4347 15.9082 14.6504 16 14.8816 16C15.1004 16 15.3079 15.9166 15.4655 15.7649C15.8003 15.4428 15.811 14.9085 15.4888 14.5735ZM6.73636 1.68522C9.36923 1.68522 11.5111 3.82713 11.5111 6.45999C11.5111 9.09286 9.36923 11.2348 6.73636 11.2348C4.10349 11.2348 1.96158 9.09286 1.96158 6.45999C1.96158 3.82713 4.10349 1.68522 6.73636 1.68522Z" fill="white"/>
                            </svg>
                          </div> -->
                        </a>
                      </div>
                      <p v-if="day.description" v-html="day.description"></p>

                      <div
                          class="itinerary-day__info"
                          v-if="day.additionalNotes"
                          v-html="day.additionalNotes">
                      </div>


                      <div v-if="day.balloonSuggestion" class="itinerary-day__banner">
                        <div class="banner__image">
                          <div class="image">
                            <img src="/images/airballoon.png" alt="balloon safari banner">
                            <div class="price">
                              {{program.header.currency === 'EUR' ? '€425' : program.header.currency === 'GBP' ? '£375' : '495$'}}
                            </div>
                          </div>

                        </div>
                        <div class="banner__title">
                          <span>{{ $t("itinerary.hotAirBalloon") }}</span>
                          <a target="_blank" :href="program.header.lang === 'EN' ? 'https://altezza.travel/en/articles/hot-air-balloon' : program.header.lang === 'RU' ? 'https://altezza.travel/articles/hot-air-balloon' : 'https://altezza.travel/de/articles/hot-air-balloon'">
                            {{ $t("itinerary.hotAirBalloonDetailed") }}
                          </a>
                        </div>
                        <div class="banner__offer">
                          <div class="banner__offer-text">
                            {{ $t("itinerary.addAirBalloonSafari", {price: program.header.currency === 'EUR' ? '€425' : program.header.currency === 'GBP' ? '£375' : '$495'}) }}
                          </div>
                          <button
                              v-if="!day.balloonSuggestion.requested && !balloonSuggestionBtn"
                              @click="isModalSendBalloonOptions = true, balloonOptions.clientId = day.balloonSuggestion.clientId"
                              class="btn btn--green"
                          >
                            <span>{{ $t("common.inquireAvailability") }}</span>
                          </button>
                          <button
                              v-if="day.balloonSuggestion.requested || balloonSuggestionBtn"
                              class="btn btn--popover-disabled"
                          >
                            <span>{{ $t("common.inquireAvailability") }}</span>
                          </button>
                        </div>
                      </div>

                    </div>
                  </template>
                  <template v-if="day.type === 'TRANSFER'">
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-pickup-car"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                          <span class="itinerary-day__top-type">{{ $t("common.transfer") }}</span>
                          {{ day.name }}
                        </h3>
                      </div>
                    </div>
                    <span class="itinerary-day__top-duration"
                          :class="{'itinerary-day__top-duration-ru': program.header.lang === 'RU' }"
                    >
                      <i class="icon-clock" :style="{marginTop: '5px'}"></i>
                      <span>{{ $t("common.duration") }}</span>
                      {{ getTimeFromMins(day.duration, program.header.lang)}}
                    </span>
                    <div class="itinerary-day__participants">
                      <div class="itinerary-day__participants-title">
                        <a>{{ $t("common.passengers") }}</a>
                        <i class="icon-arrow"></i>
                      </div>
                      <div class="itinerary-day__participants-content">
                        {{
                          day.participantNames
                              .join(', ')
                              .replace('(Non-resident)', '')
                        }}
                      </div>
                    </div>
                  </template>
                  <template
                      v-if="
                      day.type === 'TRANSIT_BEFORE_SAFARI_PARK' ||
                      day.type === 'TRANSIT_AFTER_SAFARI_PARK'
                    ">
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-transit"
                        ><img src="/images/transit-jeep.svg" alt=""
                        /></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                          {{ $t("itinerary.transferThroughNgorongoro") }}
                        </h3>
                      </div>
                    </div>
                    <div class="itinerary-day__content">
                      <div v-if="day.photos.length" class="itinerary-day__img">
                        <a
                            v-for="photo in day.photos"
                            :key="photo"
                            :data-src="`${API}/documents/share/images/${photo}?size=MEDIUM`">
                          <img
                              :src="`${API}/documents/share/images/${photo}?size=MEDIUM`"
                              class="js-lazy"
                              alt="" />
                        </a>
                      </div>
                      <p v-if="day.description" v-html="day.description"></p>
                      <div
                          class="itinerary-day__info"
                          v-if="day.additionalNotes"
                          v-html="day.additionalNotes"></div>
                    </div>
                  </template>

                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort && !(program.header.hideWelcomeTexts && index === 0)}"
                      v-if="day.type.includes('ACTIVITY')">
                    <div class="itinerary-day__top-icon">
                      <i
                          :class="
                          'icon-' +
                          (day.type.includes('MAINLAND_ACTIVITY')
                            ? 'kompass'
                            : 'air-balloon')
                        "></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">{{
                            day.type.includes('SAFARI_ACTIVITY')
                                ? $t("common.safariActivity")
                                : day.type.includes('MAINLAND_ACTIVITY')
                                    ? $t("common.dayTrip")
                                    : $t("common.activity")
                          }}</span>
                        {{ day.name }}
                      </h3>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__content"
                      v-if="day.type.includes('ACTIVITY')">
                    <div class="itinerary-day__img">
                      <a
                          v-for="photo in day.photos"
                          :key="photo"
                          :data-src="`${API}/documents/share/images/${photo}?size=MEDIUM`">
                        <img
                            :src="`${API}/documents/share/images/${photo}?size=MEDIUM`"
                            class="js-lazy"
                            alt="" />
                        <!-- <div class="zoom">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.4888 14.5735L11.6808 10.6129C12.6599 9.44901 13.1964 7.98455 13.1964 6.45999C13.1964 2.89801 10.2983 0 6.73636 0C3.17438 0 0.276367 2.89801 0.276367 6.45999C0.276367 10.022 3.17438 12.92 6.73636 12.92C8.07358 12.92 9.34788 12.5167 10.4374 11.751L14.2743 15.7416C14.4347 15.9082 14.6504 16 14.8816 16C15.1004 16 15.3079 15.9166 15.4655 15.7649C15.8003 15.4428 15.811 14.9085 15.4888 14.5735ZM6.73636 1.68522C9.36923 1.68522 11.5111 3.82713 11.5111 6.45999C11.5111 9.09286 9.36923 11.2348 6.73636 11.2348C4.10349 11.2348 1.96158 9.09286 1.96158 6.45999C1.96158 3.82713 4.10349 1.68522 6.73636 1.68522Z" fill="white"/>
                          </svg>
                        </div> -->
                      </a>
                    </div>
                    <!-- v-if="day.type.includes('MAINLAND_ACTIVITY')" -->
                    <div
                        class="itinerary-day__participants itinerary-day__participants-trip">
                      <div class="itinerary-day__participants-title">
                        <a>{{ $t("common.participants") }}</a>
                        <i class="icon-arrow"></i>
                      </div>
                      <div
                          class="itinerary-day__participants-content"
                          :class="{
                          lowercase:
                            program.header.lang === 'EN' ||
                            program.header.lang === 'RU',
                        }">
                        <template v-for="(n, _ind) in day.participantNames">
                          {{ n.replace('(Non-resident)', '')
                          }}{{
                            _ind !== day.participantNames.length - 1 ? ',' : ''
                          }}
                        </template>
                      </div>
                    </div>
                    <p v-if="day.description" v-html="day.description"></p>
                    <div
                        class="itinerary-day__info"
                        v-if="day.additionalNotes"
                        v-html="day.additionalNotes"></div>
                    <div
                        class="itinerary-day__info"
                        v-if="day.whatToBring"
                        v-html="day.whatToBring"></div>
                  </div>
                </div>
                <div
                    class="itinerary-day__item"
                    v-for="(transfer, idx) in item.transfers.filter(
                    (thing, idx, self) =>
                      idx === self.findIndex((t) => t.name === thing.name)
                  )"
                    :key="idx + 'tr'">
                  <div
                      v-if="transfer.afterActivity === true"
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort}">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-pickup-car"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.transfer") }}</span>
                        {{ transfer.name }}
                      </h3>
                    </div>
                  </div>
                  <span v-if="transfer.afterActivity === true" class="itinerary-day__top-duration">
                    <i class="icon-clock" :style="{marginTop: '5px'}"></i>
                    <span>{{ $t("common.duration") }}</span>
                    {{ getTimeFromMins(transfer.duration, program.header.lang)}}
                  </span>
                  <div v-if="transfer.afterActivity === true" class="itinerary-day__participants">
                    <div class="itinerary-day__participants-title">
                      <a>{{ $t("common.passengers") }}</a>
                      <i class="icon-arrow"></i>
                    </div>
                    <div
                        class="itinerary-day__participants-content"
                        :class="{
                        lowercase:
                          program.header.lang === 'EN' ||
                          program.header.lang === 'RU',
                      }">
                      <template v-for="(n, _ind) in transfer.participantNames">
                        {{ n.replace('(Non-resident)', '')
                        }}{{
                          _ind !== transfer.participantNames.length - 1
                              ? ','
                              : ''
                        }}
                      </template>
                    </div>
                  </div>
                </div>

                <div
                    class="itinerary-day__item"
                    v-if="index === program.body.days.length - 1">
                  <div
                      class="itinerary-day__top"
                      :class="{'itinerary-day__top--padding': !isShort}">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-info"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        {{ $t("common.endOfAdventureWithAltezza") }}
                      </h3>
                    </div>
                  </div>
                  <div class="itinerary-day__content">
                    <p v-html="program.footer.backText"></p>
                  </div>
                </div>
                <div
                    v-if="item.notes && item.dayInfo.length"
                    class="itinerary-day__content">
                  <div class="notes">
                    <div class="notes__title">
                      <img src="/images/notes-yellow-icon.svg" alt="" />
                      <b>{{ $t("common.notes") }}</b>
                    </div>
                    <div v-html="item.notes" class="notes__body"></div>
                  </div>
                </div>
              </div>
            </div>
            <!--!isShort end-->

            <!--isShort start-->
            <div class="itinerary-days itinerary-days__short" v-if="isShort ">
              <div
                  v-for="(item, index) in program.body.days"
                  :key="index"
                  class="itinerary-day"
                  :class="[
                  // {'itinerary-day': item.dayInfo[0].type !== 'TRANSFER'},
                  { 'itinerary-day__arrival': item.dayInfo[0] ? item.dayInfo[0].type === 'ARRIVAL' : false, },
                ]">
                <!--                {{item.dayInfo[0].type !== 'TRANSFER'}}-->
                <!--                <template v-if="item.dayInfo[0].type !== 'TRANSFER'">-->
                <template>
                  <div class="itinerary-day__date">
                  <span>
                    <span>
                      {{program.frontendMeta.tourStart ? item.date.split(' ')[0] : index + 1}}
                    </span>
                    {{program.frontendMeta.tourStart ? item.date.split(' ')[1].substring(0, 3) : $t("common.day_one")}}
                  </span>
                    <div class="itinerary-day__date-year">
                      {{item.year ? item.year : program.frontendMeta.tourStart
                        ? program.header.travelDates.start.split(' ')[2]
                        : '-'}}
                    </div>
                  </div>
                  <div
                      class="itinerary-day__item itinerary-day__item-scroll"
                      v-for="(day, idx) in item.dayInfo"
                      :key="idx + 'd'"
                      :id="'day' +  JSON.stringify( program.body.days.slice(0, index).map((day) => (day.dayInfo ? day.dayInfo.length : 0)).reduce((acc, value) => acc + value, 0) + idx + 1)"
                      v-if="day.type !== 'INFO'">
                    <!--                      {{day.type}}-->
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="
                      day.type === 'ARRIVAL' ||
                      day.type === 'DEPARTURE' ||
                      day.type === 'FLIGHT'
                    ">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-airplane"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>{{ day.name }}</h3>
                      </div>
                    </div>

                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="day.type === 'TRANSFER'">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-pickup-car"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>{{ day.name }}</h3>
                      </div>
                    </div>

                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="day.type === 'ACCOMMODATION'">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-bed"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.accommodation") }}</span>
                          {{ day.name }}
                          <ul class="stars-rating">
                            <li>
                              <i class="icon-star" v-if="day.ratio > 0"></i>
                            </li>
                            <li>
                              <i class="icon-star" v-if="day.ratio > 1"></i>
                            </li>
                            <li>
                              <i class="icon-star" v-if="day.ratio > 2"></i>
                            </li>
                            <li>
                              <i class="icon-star" v-if="day.ratio > 3"></i>
                            </li>
                            <li>
                              <i class="icon-star" v-if="day.ratio > 4"></i>
                            </li>
                          </ul>
                        </h3>
                        <span class="itinerary-day__top-upgrade">
                          <i class="icon-diamond"></i>
                            Upgrade hotel
                          </span>
                      </div>
                    </div>
                    <div
                        class="itinerary-day__content"
                        v-if="day.type === 'ACCOMMODATION'">
                        <span class="itinerary-day__basis">
                          <i class="icon-chocolate"></i>
                        <span>{{ $t("common.mealPlan") }}:</span>
                      {{ day.hotelInfo.rooms.map((item) => item.mealType).join(', ')}}
                      </span>
                      <span class="itinerary-day__basis">
                        <i class="icon-bed3"></i>
                        <span>{{ $t("common.roomType") }}:</span>
                          {{ day.hotelInfo.rooms.map((item) => item.roomName).join(', ')}}
                        </span>
                    </div>

                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="day.type === 'CLIMBING'">
                      <div class="itinerary-day__top-icon">
                        <i :class="'icon-' + (item.dayInfo[idx - 1] && (item.dayInfo[idx - 1].name.includes('Summit') || item.dayInfo[idx - 1].name.includes('штурм')) ? 'finish' : 'mountain')"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                        <span
                            class="itinerary-day__top-type"
                            v-if="program.header.lang !== 'RU'"
                        >
                          {{ $t("common.expeditionDay") }}
                          {{ day.day }}
                        </span>
                          <span
                              class="itinerary-day__top-type"
                              v-if="program.header.lang === 'RU'"
                          >{{
                              day.day === 1
                                  ? 'Первый'
                                  : day.day === 2
                                      ? 'Второй'
                                      : day.day === 3
                                          ? 'Третий'
                                          : day.day === 4
                                              ? 'Четвертый'
                                              : day.day === 5
                                                  ? 'Пятый'
                                                  : day.day === 6
                                                      ? 'Шестой'
                                                      : day.day === 7
                                                          ? 'Седьмой'
                                                          : day.day === 8
                                                              ? 'Восьмой'
                                                              : day.day === 9
                                                                  ? 'Девятый'
                                                                  : day.day === 10
                                                                      ? 'Десятый'
                                                                      : day.day === 11
                                                                          ? 'Одинадцатый'
                                                                          : day.day === 12
                                                                              ? 'Двенадцатый'
                                                                              : day.day === 13
                                                                                  ? 'Тринадцатый'
                                                                                  : day.day === 14
                                                                                      ? 'Четырнадцатый'
                                                                                      : day.day === 15
                                                                                          ? 'Пятнадцатый'
                                                                                          : ''
                            }}
                          день экспедиции</span
                          >
                          {{ day.name }}
                        </h3>
                      </div>
                    </div>

                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="day.type.includes('SAFARI_PARK')">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-pawprint"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.safari") }}</span>
                          {{ day.name }}
                        </h3>
                      </div>
                    </div>

                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="day.type.includes('ACTIVITY')">
                      <div class="itinerary-day__top-icon">
                        <i
                            :class="
                          'icon-' +
                          (day.type.includes('MAINLAND_ACTIVITY')
                            ? 'kompass'
                            : 'air-balloon')
                        "></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                        <span class="itinerary-day__top-type">
                          {{
                            day.type.includes('SAFARI_ACTIVITY')
                                ? $t("common.safariActivity")
                                : day.type.includes('MAINLAND_ACTIVITY')
                                    ? $t("common.dayTrip")
                                    : $t("common.activity")
                          }}
                        </span>
                          {{ day.name }}
                        </h3>
                      </div>
                    </div>
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}"
                        v-if="
                      day.type === 'INFO' ||
                      day.type === 'REST_DAY' ||
                      day.type === 'OWN_ARRANGEMENTS'
                    ">
                      <div class="itinerary-day__top-icon">
                        <i v-if="day.type === 'INFO'" class="icon-info"></i>
                        <i
                            v-if="day.type === 'OWN_ARRANGEMENTS'"
                            class="icon-info icon-info-none">
                          <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                              <path
                                  d="M13.1807 17.6172H4.93848C4.19418 17.6172 3.59082 18.2205 3.59082 18.9648V19.375C3.59082 19.4829 3.67828 19.5703 3.78613 19.5703H14.333C14.4409 19.5703 14.5283 19.4829 14.5283 19.375V18.9648C14.5283 18.2205 13.9249 17.6172 13.1807 17.6172Z"
                                  fill="white" />
                              <path
                                  d="M5.54395 16.5625V17.2266H12.5752V16.5625C12.5752 15.8506 11.998 15.2734 11.2861 15.2734H6.83301C6.12105 15.2734 5.54395 15.8506 5.54395 16.5625Z"
                                  fill="white" />
                              <path
                                  d="M10.0361 1.40625C10.0361 0.866914 9.5989 0.429688 9.05957 0.429688C8.52023 0.429688 8.08301 0.866914 8.08301 1.40625V14.8828H10.0361V1.40625Z"
                                  fill="white" />
                              <path
                                  d="M7.69239 4.92188H2.41895L-0.112536 6.73008C-0.21574 6.80379 -0.222419 6.95477 -0.12613 7.0373L2.41895 9.21875H7.69239V4.92188Z"
                                  fill="white" />
                              <path
                                  d="M10.4268 7.46094V11.7578H15.5816L18.1131 9.94965C18.2163 9.87594 18.223 9.72496 18.1267 9.64242L15.5816 7.46094H10.4268Z"
                                  fill="white" />
                              <path
                                  d="M18.1267 4.95492L15.5816 2.77344H10.4268V7.07031H15.5816L18.1131 5.26215C18.2163 5.18844 18.223 5.03746 18.1267 4.95492Z"
                                  fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                        <i
                            v-if="day.type === 'REST_DAY'"
                            class="icon-info icon-info-none">
                          <svg
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                              <path
                                  d="M15.6226 13.5693H11.1104V7.60685H13.0229C13.0012 5.98006 12.6961 4.32455 12.1779 3.03754C11.7001 1.8506 11.0777 1.11328 10.5538 1.11328C10.0298 1.11328 9.40752 1.8506 8.92967 3.03754C8.41155 4.32452 8.10641 5.98006 8.0847 7.60685H9.99715V13.5693H6.41939L4.78533 11.9353C3.61405 10.764 1.70832 10.764 0.537081 11.9353C0.432693 12.0397 0.374023 12.1813 0.374023 12.3289C0.374023 12.4765 0.432693 12.6181 0.537081 12.7224L4.55896 16.7443C4.55054 16.7654 4.5429 16.787 4.53692 16.8095L4.14286 18.301C4.06434 18.5982 4.24164 18.9029 4.53885 18.9814C4.5865 18.994 4.63433 19 4.68139 19C4.9279 19 5.15327 18.8349 5.21921 18.5854L5.60373 17.1299H16.3561V18.4432C16.3561 18.7506 16.6053 18.9999 16.9127 18.9999C17.2201 18.9999 17.4694 18.7506 17.4694 18.4432V17.1299H18.0699C18.3773 17.1299 18.6266 16.8807 18.6266 16.5733C18.6266 14.9169 17.279 13.5693 15.6226 13.5693Z"
                                  fill="white" />
                              <path
                                  d="M13.2105 2.62176C13.7796 4.03528 14.1142 5.84223 14.1362 7.60684H17.0473C17.3547 7.60684 17.6039 7.35762 17.6039 7.05021C17.6039 3.16273 14.4412 0 10.5537 0C11.5863 0 12.5299 0.931104 13.2105 2.62176Z"
                                  fill="white" />
                              <path
                                  d="M7.89729 2.62176C8.57798 0.931104 9.52152 0 10.5542 0C6.6666 0 3.50391 3.16273 3.50391 7.05021C3.50391 7.35762 3.75313 7.60684 4.06054 7.60684H6.97164C6.99368 5.84227 7.32822 4.03532 7.89729 2.62176Z"
                                  fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="19" height="19" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>{{ day.name }}</h3>
                      </div>
                    </div>
                  </div>
                  <div
                      class="itinerary-day__item"
                      v-for="(transfer, idx) in item.transfers"
                      :key="idx + 't'">
                    <div
                        class="itinerary-day__top"
                        :class="{'itinerary-day__top--padding': !isShort}">
                      <div class="itinerary-day__top-icon">
                        <i class="icon-pickup-car"></i>
                      </div>
                      <div class="itinerary-day__top-info">
                        <h3>
                        <span class="itinerary-day__top-type">{{ $t("common.transfer") }}</span>
                          {{ transfer.name }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </template>

              </div>
              <!--
              <div class="itinerary-day">
                <div class="itinerary-day__date">
                  <span>
                    <span>12</span>
                    may
                  </span>
                  <div class="itinerary-day__date-year">2022</div>
                </div>
                <div class="itinerary-day__item">
                  <div class="itinerary-day__top">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-kompass"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        <span class="itinerary-day__top-type">Day trip</span>
                        Materuni waterfall
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="itinerary-day itinerary-day__no">
                <div class="itinerary-day__date">
                  <span>
                    <span>13</span>
                    may
                  </span>
                  <div class="itinerary-day__date-year">2022</div>
                </div>
                <div class="itinerary-day__item">
                  <div class="itinerary-day__top">
                    <div class="itinerary-day__top-icon">
                      <i class="icon-close"></i>
                    </div>
                    <div class="itinerary-day__top-info">
                      <h3>
                        NO ANY BOOKINGS WITH US (UNTIL 16 MAY)
                      </h3>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
            <!--isShort end-->

            <div class="itinerary-extra" v-if="program.header.notesForClients">
              <h2>
                {{ $t("common.extraNotesToProgram") }}
              </h2>
              <div
                  class="itinerary-extra__block"
                  v-html="program.header.notesForClients"></div>
            </div>
            <div
                class="itinerary-summary"
                id="itinerary-summary"
                v-if="!program.header.itineraryWithoutPrice && !hidePrice">
              <h2>
                {{ $t("common.priceSummary") }}
              </h2>
              <div class="itinerary-summary__pax">
                <span>{{ $t("common.participants") }}:</span>
                <ul>
                  {{
                    program.header.itineraryWithNames
                        ? program.header.participantCosts
                            .map((item) => item.info)
                            .join(', ')
                        : program.header.guests
                            .map((item) => `${item.count} ${item.ageName}`)
                            .join(', ')
                  }}
                </ul>
              </div>

              <div
                  v-if="program.header.additionalServicesCost.length || program.header.climbingAdditionalOptionsCost.length"
                  class="itinerary-summary__block">
                <h3 class="normal">
                  {{ $t("common.additionalOptions") }}
                </h3>
                <div class="itinerary-summary__subtext">
                  ({{ $t("itinerary.includedInPricePerPersonBelow") }})
                </div>
                <ul>
                  <li
                      v-for="(item, index) in program.header
                      .additionalServicesCost"
                      :key="index">
                    <span>{{ item.info.replace('(Non-resident)', '') }}:</span>
                    <b> {{
                        getCurrencySign(program.header.currency)
                      }}{{ item.totalAmount }} </b>
                  </li>
                  <li v-for="(item, index) in program.header.climbingAdditionalOptionsCost" :key="index">
                    <span style="display:flex;align-items: center">
                      <span style="display:flex;">
                        <svg
                            width="20px"
                            height="20px"
                            style="width: 20px; height: 20px;"
                            class="icon icon-categories">
                                <use
                                    xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing-gray"></use></svg
                        >
                      </span>
                      <span>{{ item.name }}</span>
                    </span>
                    <b>{{
                        getCurrencySign(program.header.currency)
                      }}{{item.amount}}</b>
                  </li>
                </ul>
              </div>

              <div class="itinerary-summary__block">
                <h3>
                  {{ $t("common.pricePerPerson") }}:
                </h3>
                <ul>
                  <li
                      v-for="(item, index) in program.header.participantCosts"
                      :key="index">
                    <span>{{ item.info.replace('(Non-resident)', '') }}:</span>
                    <b>
                      <template
                          v-if="
                          item.personalDiscount &&
                          !item.hideForClientPersonalDiscount
                        ">
                        <span class="itinerary-summary__old-price"
                        >{{
                            getCurrencySign(program.header.currency)
                          }}{{ item.totalAmount + item.personalDiscount }}</span
                        >
                      </template>
                      {{
                        getCurrencySign(program.header.currency)
                      }}{{ item.totalAmount }}
                    </b>
                  </li>
                </ul>
                <span class="itinerary-summary__total">
                  <span>
                    {{ $t("common.totalAmount") }}:
                  </span>
                  {{
                    getCurrencySign(program.header.currency)
                  }}{{ numberWithCommas(program.header.totalAmount) }}
                </span>
              </div>

              <div
                  class="itinerary-summary__payment-block"
                  v-if="program.header.allowStripe">
                <div class="itinerary-summary__payment">
                  <div class="itinerary-summary__payment-methods">
                    <span
                    >{{ $t("common.paymentMethods") }}:</span
                    >
                    <ul>
                      <li><img src="/images/payment-icon1.svg" alt="" /></li>
                      <li><img src="/images/payment-icon2.svg" alt="" /></li>
                      <li><img src="/images/payment-icon3.png" alt="" /></li>
                      <li><img src="/images/payment-icon4.svg" alt="" /></li>
                      <li><img src="/images/payment-icon5.svg" alt="" /></li>
                    </ul>
                  </div>
                  <a
                      href="#"
                      class="btn btn-green"
                      @click="modalPayStripeShow = true"
                  >{{ $t("common.payViaStripe") }}</a
                  >
                </div>
                <div class="itinerary-summary__add">
                  {{ $t("common.payViaOtherMethod") }}
                </div>
              </div>
              <div
                  class="itinerary-summary__payment-block"
                  v-if="!program.header.allowStripe">
                <div class="itinerary-summary__payment">
                  <div class="itinerary-summary__payment-methods">
                    <span>{{ $t("common.paymentMethods") }}:</span>
                    <ul>
                      <li><img src="/images/payment-icon1.svg" alt="" /></li>
                      <li><img src="/images/payment-icon2.svg" alt="" /></li>
                      <li><img src="/images/payment-icon3.png" alt="" /></li>
                      <li><img src="/images/payment-icon4.svg" alt="" /></li>
                      <li><img src="/images/payment-icon5.svg" alt="" /></li>
                    </ul>
                  </div>
                  <span class="btn btn-green disabled">{{ $t("common.payViaStripe") }}</span>
                </div>
                <div class="itinerary-summary__add">
                  {{ $t("itinerary.contactManagerToActivateTourPayment") }}
                </div>
              </div>
            </div>
            <div v-for="(mountain) in program.details.climbings" v-if="!hidePrice" id="itinerary-climbing">
              <h2 style="margin-top: 50px">
                {{ program.details.climbings.length > 1 ? mountain.mountName : ' ' + $t("common.climbingCostIncludes") }}
              </h2>
              <ItineraryIncludesExcludesSpoiler v-for="(value, key) in mountain.details.inclusion" v-if="value"
                                                :language="program.header.lang" :description="value" :itemKey="key"/>
              <h2 style="margin-top: 50px">
                {{ program.details.climbings.length > 1 ? mountain.mountName : '' + ' ' + $t("common.climbingCostExcludes") }}
              </h2>
              <ItineraryIncludesExcludesSpoiler v-for="(value, key) in mountain.details.exclusion" v-if="value" :language="program.header.lang" :description="value" :itemKey="key"/>
            </div>
            <div
                class="itinerary-includes"
                id="itinerary-safari"
                v-if="program.details.safari && !hidePrice">
              <h2>
                {{ $t("common.safariCostIncludes") }}
              </h2>
              <div class="itinerary-includes__block">
                <div
                    :class="[
                    'includes-item',
                    {active: collapse.safari.transfers},
                  ]"
                    @click="
                    collapse.safari.transfers = !collapse.safari.transfers
                  ">
                  <div class="includes-item__head">
                    <h3>
                      <i class="icon-pickup-car"></i>
                      {{ $t("common.transfers") }}
                    </h3>
                    <span class="includes-item__head-btn">
                      <i class="icon-arrow"></i>
                    </span>
                  </div>
                  <div
                      class="includes-item__content"
                      v-html="program.details.safari.inclusion.transfers"></div>
                </div>
                <div
                    :class="['includes-item', {active: collapse.safari.accom}]"
                    @click="collapse.safari.accom = !collapse.safari.accom">
                  <div class="includes-item__head">
                    <h3>
                      <i class="icon-bed2"></i
                      >{{ $t("common.accommodationAndMeals") }}
                    </h3>
                    <span class="includes-item__head-btn">
                      <i class="icon-arrow"></i>
                    </span>
                  </div>
                  <div
                      class="includes-item__content"
                      v-html="
                      program.details.safari.inclusion.accommodations
                    "></div>
                </div>
                <div
                    :class="['includes-item', {active: collapse.safari.hiking}]"
                    @click="collapse.safari.hiking = !collapse.safari.hiking">
                  <div class="includes-item__head">
                    <h3>
                      <svg
                          width="24"
                          :style="{marginRight: '5px'}"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.8291 13.732V13.7957C20.8291 13.828 20.8354 13.8599 20.8477 13.8898C20.86 13.9196 20.8781 13.9467 20.9009 13.9695C20.9238 13.9923 20.9509 14.0104 20.9807 14.0227C21.0105 14.0351 21.0425 14.0414 21.0747 14.0413H22.6047V13.4863H21.0747C21.0096 13.4865 20.9473 13.5125 20.9013 13.5585C20.8552 13.6045 20.8293 13.6669 20.8291 13.732Z"
                            fill="#525252" />
                        <path
                            d="M20.1841 11.1167H18.1703C17.9426 11.1162 17.7228 11.0331 17.5517 10.8827C17.3807 10.7323 17.27 10.525 17.2403 10.2992L17.1372 9.4986C17.0378 8.73843 16.6657 8.04024 16.0901 7.53392C15.5144 7.0276 14.7744 6.74763 14.0078 6.74609H3.50781C3.35877 6.74654 3.21595 6.80595 3.11056 6.91134C3.00516 7.01673 2.94576 7.15955 2.94531 7.30859V16.3405C2.94576 16.4895 3.00516 16.6323 3.11056 16.7377C3.21595 16.8431 3.35877 16.9025 3.50781 16.903H4.43219C4.51659 16.0543 4.91344 15.2673 5.54564 14.6948C6.17784 14.1224 7.00026 13.8054 7.85313 13.8054C8.70599 13.8054 9.52841 14.1224 10.1606 14.6948C10.7928 15.2673 11.1897 16.0543 11.2741 16.903H14.2253C14.3097 16.0543 14.7066 15.2673 15.3388 14.6948C15.971 14.1224 16.7934 13.8054 17.6463 13.8054C18.4991 13.8054 19.3215 14.1224 19.9537 14.6948C20.5859 15.2673 20.9828 16.0543 21.0672 16.903H22.0422C22.1912 16.9025 22.3341 16.8431 22.4394 16.7377C22.5448 16.6323 22.6042 16.4895 22.6047 16.3405V14.7899H21.0747C20.8107 14.7897 20.5575 14.6848 20.3708 14.4981C20.1842 14.3114 20.0792 14.0582 20.0791 13.7942V13.7305C20.0792 13.4665 20.1842 13.2133 20.3708 13.0266C20.5575 12.8399 20.8107 12.735 21.0747 12.7348H22.4678C22.3011 12.2622 21.9919 11.8528 21.583 11.563C21.174 11.2733 20.6853 11.1173 20.1841 11.1167ZM9.589 10.5589C9.5887 10.8075 9.48984 11.0457 9.31409 11.2215C9.13833 11.3972 8.90005 11.4961 8.6515 11.4964H5.00856C4.76001 11.4961 4.52173 11.3972 4.34598 11.2215C4.17023 11.0457 4.07136 10.8075 4.07106 10.5589V8.8086C4.07136 8.56005 4.17023 8.32176 4.34598 8.14601C4.52173 7.97026 4.76001 7.87139 5.00856 7.87109H8.6515C8.90005 7.87139 9.13833 7.97026 9.31409 8.14601C9.48984 8.32176 9.5887 8.56005 9.589 8.8086V10.5589ZM15.9496 11.1658C15.8616 11.2696 15.7521 11.3528 15.6287 11.4099C15.5053 11.467 15.371 11.4965 15.235 11.4964H11.2225C10.974 11.4961 10.7357 11.3972 10.5599 11.2215C10.3842 11.0457 10.2853 10.8075 10.285 10.5589V8.8086C10.2853 8.56005 10.3842 8.32176 10.5599 8.14601C10.7357 7.97026 10.974 7.87139 11.2225 7.87109H14.1798C14.6241 7.86846 15.0544 8.02666 15.3912 8.31649C15.728 8.60632 15.9486 9.00821 16.0122 9.44797C16.0615 9.77797 16.1142 10.1213 16.1609 10.4063C16.1831 10.5406 16.1756 10.6782 16.1391 10.8094C16.1026 10.9406 16.0379 11.0622 15.9496 11.1658Z"
                            fill="#525252" />
                        <path
                            d="M8.65173 8.62109H5.00879C4.90524 8.62109 4.82129 8.70504 4.82129 8.80859V10.5587C4.82129 10.6623 4.90524 10.7462 5.00879 10.7462H8.65173C8.75528 10.7462 8.83923 10.6623 8.83923 10.5587V8.80859C8.83923 8.70504 8.75528 8.62109 8.65173 8.62109Z"
                            fill="#525252" />
                        <path
                            d="M15.2698 9.56252C15.2319 9.30108 15.1007 9.06218 14.9004 8.88988C14.7002 8.71758 14.4444 8.6235 14.1802 8.62502H11.2231C11.1734 8.62502 11.1257 8.64477 11.0906 8.67994C11.0554 8.7151 11.0356 8.76279 11.0356 8.81252V10.5628C11.0356 10.6126 11.0554 10.6603 11.0906 10.6954C11.1257 10.7306 11.1734 10.7503 11.2231 10.7503H15.2356C15.2634 10.7521 15.2911 10.7473 15.3166 10.7364C15.3422 10.7255 15.3648 10.7089 15.3828 10.6877C15.4007 10.6665 15.4135 10.6414 15.4201 10.6144C15.4266 10.5875 15.4268 10.5593 15.4205 10.5323C15.3731 10.2422 15.3198 9.89514 15.2698 9.56252Z"
                            fill="#525252" />
                        <path
                            d="M17.6474 16.5293C17.5061 16.5291 17.368 16.5708 17.2505 16.6491C17.1329 16.7274 17.0413 16.8389 16.9872 16.9693C16.933 17.0998 16.9188 17.2433 16.9463 17.3819C16.9738 17.5204 17.0418 17.6477 17.1416 17.7475C17.2415 17.8474 17.3688 17.9154 17.5073 17.9429C17.6458 17.9704 17.7894 17.9562 17.9198 17.902C18.0503 17.8479 18.1617 17.7562 18.2401 17.6387C18.3184 17.5212 18.3601 17.383 18.3599 17.2418C18.3594 17.053 18.2841 16.872 18.1506 16.7385C18.0171 16.605 17.8362 16.5298 17.6474 16.5293Z"
                            fill="#525252" />
                        <path
                            d="M7.8523 16.5293C7.71111 16.5293 7.57309 16.5712 7.45571 16.6496C7.33833 16.7281 7.24687 16.8396 7.19289 16.9701C7.13891 17.1006 7.12484 17.2441 7.15247 17.3826C7.18009 17.521 7.24817 17.6482 7.34809 17.7479C7.448 17.8477 7.57526 17.9156 7.71377 17.943C7.85227 17.9704 7.99579 17.9561 8.12617 17.9019C8.25655 17.8477 8.36792 17.7561 8.4462 17.6386C8.52448 17.5211 8.56614 17.383 8.56592 17.2418C8.56547 17.0528 8.49011 16.8716 8.35634 16.7381C8.22258 16.6045 8.04132 16.5294 7.8523 16.5293Z"
                            fill="#525252" />
                        <path
                            d="M7.85248 14.5566C7.32125 14.5568 6.80201 14.7145 6.36041 15.0098C5.91882 15.3051 5.5747 15.7247 5.37158 16.2156C5.16846 16.7064 5.11545 17.2465 5.21927 17.7675C5.32309 18.2885 5.57907 18.767 5.95484 19.1425C6.3306 19.518 6.80928 19.7736 7.33034 19.8771C7.8514 19.9805 8.39143 19.9272 8.88215 19.7237C9.37287 19.5202 9.79223 19.1758 10.0872 18.734C10.3822 18.2922 10.5395 17.7729 10.5394 17.2416C10.5388 16.5294 10.2555 15.8465 9.75167 15.343C9.24785 14.8395 8.56474 14.5567 7.85248 14.5566ZM7.85248 18.706C7.563 18.706 7.28003 18.6202 7.03934 18.4593C6.79864 18.2985 6.61105 18.0699 6.50027 17.8025C6.38949 17.535 6.36051 17.2408 6.41698 16.9568C6.47345 16.6729 6.61285 16.4121 6.81754 16.2074C7.02223 16.0028 7.28303 15.8634 7.56694 15.8069C7.85086 15.7504 8.14514 15.7794 8.41259 15.8902C8.68003 16.001 8.90862 16.1885 9.06944 16.4292C9.23027 16.6699 9.31611 16.9529 9.31611 17.2424C9.31571 17.6304 9.1614 18.0024 8.88705 18.2768C8.61269 18.5512 8.24069 18.7056 7.85267 18.706H7.85248Z"
                            fill="#525252" />
                        <path
                            d="M1.29932 8.95313V14.7C1.29932 14.7497 1.31907 14.7974 1.35423 14.8326C1.3894 14.8677 1.43709 14.8875 1.48682 14.8875H2.19557V8.76562H1.48682C1.43709 8.76562 1.3894 8.78538 1.35423 8.82054C1.31907 8.85571 1.29932 8.9034 1.29932 8.95313Z"
                            fill="#525252" />
                        <path
                            d="M17.6473 14.5566C17.116 14.5565 16.5966 14.7138 16.1547 15.0089C15.7129 15.304 15.3685 15.7235 15.1651 16.2143C14.9617 16.7051 14.9084 17.2452 15.012 17.7663C15.1156 18.2875 15.3715 18.7661 15.7471 19.1418C16.1228 19.5175 16.6015 19.7733 17.1226 19.8769C17.6437 19.9805 18.1839 19.9273 18.6747 19.7239C19.1655 19.5205 19.585 19.1761 19.88 18.7342C20.1751 18.2924 20.3325 17.7729 20.3323 17.2416C20.3313 16.5298 20.0481 15.8475 19.5448 15.3442C19.0415 14.8408 18.3591 14.5576 17.6473 14.5566ZM17.6473 18.706C17.3578 18.7062 17.0747 18.6206 16.8339 18.4599C16.593 18.2992 16.4053 18.0707 16.2943 17.8033C16.1834 17.5358 16.1542 17.2415 16.2106 16.9575C16.2669 16.6735 16.4062 16.4127 16.6109 16.2078C16.8155 16.003 17.0763 15.8635 17.3602 15.807C17.6442 15.7504 17.9385 15.7793 18.206 15.8901C18.4735 16.0008 18.7022 16.1884 18.8631 16.4291C19.024 16.6698 19.1098 16.9529 19.1098 17.2424C19.1094 17.6303 18.9552 18.0021 18.681 18.2765C18.4068 18.5509 18.035 18.7053 17.6471 18.706H17.6473Z"
                            fill="#525252" />
                        <path
                            d="M14.8463 4.24805H2.87256C2.7731 4.24805 2.67772 4.28756 2.60739 4.35788C2.53707 4.42821 2.49756 4.52359 2.49756 4.62305C2.49756 4.7225 2.53707 4.81789 2.60739 4.88821C2.67772 4.95854 2.7731 4.99805 2.87256 4.99805H3.71068V5.99742H4.46068V4.99805H8.48443V5.99742H9.23443V4.99805H13.2582V5.99742H14.0082V4.99805H14.8463C14.9458 4.99805 15.0411 4.95854 15.1115 4.88821C15.1818 4.81789 15.2213 4.7225 15.2213 4.62305C15.2213 4.52359 15.1818 4.42821 15.1115 4.35788C15.0411 4.28756 14.9458 4.24805 14.8463 4.24805Z"
                            fill="#525252" />
                      </svg>
                      {{ $t("itinerary.safariGuiding") }}
                    </h3>
                    <span class="includes-item__head-btn">
                      <i class="icon-arrow"></i>
                    </span>
                  </div>
                  <div
                      class="includes-item__content"
                      v-html="program.details.safari.inclusion.guiding"></div>
                </div>
              </div>
            </div>
            <div
                class="itinerary-includes__add"
                v-if="program.details.safari && !hidePrice">
              <h2>
                {{ $t("common.safariCostExcludes") }}
              </h2>
              <div
                  class="itinerary-includes__add-block"
                  v-html="program.details.safari.exclusion"></div>
            </div>
            <div class="itinerary-wish">
              <h2>
                <i class="icon-sun2"></i
                >{{ $t("common.wishPleasantTrip") }}
              </h2>
              <p>
                {{ $t("common.soonStartAdventureText") }}
                <br />
                <br />
                {{ $t("itinerary.topOfVulcanText") }}
                <br v-if="program.header.lang === 'EN'" />
                <br v-if="program.header.lang === 'EN'" />
                {{ $t("itinerary.tanzaniaDescription") }}
                <a v-if="program.header.lang === 'EN'" href="https://altezzatravel.com/articles/what-not-to-do-on-tanzania-trip" target="_blank">
                  Tanzania dos and don'ts.
                </a>
                {{ $t("itinerary.giveAReadBeforeTrip") }}
                <br />
                <br />
                {{ $t("itinerary.sunriseOpportunity") }}
                <br v-if="program.header.lang === 'EN'" />
                <br v-if="program.header.lang === 'EN'" />
                {{ $t("itinerary.clickReviews") }}
                <a v-if="program.header.lang === 'RU'" href="https://www.tripadvisor.ru/Attraction_Review-g317084-d12583793-Reviews-Altezza_Travel-Moshi_Kilimanjaro_Region.html">
                  {{ $t("common.here") }}
                </a>
                <a v-else-if="program.header.lang === 'DE'" href="https://www.tripadvisor.com/Attraction_Review-g317084-d12583793-Reviews-Altezza_Travel-Moshi_Kilimanjaro_Region.html">
                  {{ $t("common.here") }}
                </a>
                <a v-else href="https://www.tripadvisor.com/Attraction_Review-g317084-d12583793-Reviews-Altezza_Travel-Moshi_Kilimanjaro_Region.html">
                  {{ $t("common.here") }}
                </a>
                {{ $t("itinerary.clickReviewsEnd") }}
              </p>
            </div>
          </div>
          <div :class="['itinerary-aside__box', {active: openMenu}]">
            <div class="itinerary-aside">
              <div class="itinerary-aside__logo">
                <img
                    v-if="branding === 'false'"
                    src="/images/itinerary-logo.svg"
                    alt="" />
                <img
                    v-else-if="branding === 'true'"
                    src="/images/luxury-short-safari.svg"
                    alt="" />
              </div>
              <div class="itinerary-aside__options">
                <a
                    href="#"
                    :class="['btn js-btn-full', {active: !isShort}]"
                    @click.prevent="isShort = false"
                ><i class="icon-list"></i
                >{{ $t("common.fullItinerary") }}</a
                >
                <a
                    href="#"
                    :class="['btn js-btn-short', {active: isShort}]"
                    @click.prevent="isShort = true"
                ><i class="icon-list2"></i
                >{{ $t("common.shortItinerary") }}</a
                >
              </div>
              <div class="itinerary-aside__download">
                <a
                    href="#"
                    :class="['btn itinerary-aside__download-btn', {disabled: isPdfButtonDisabled}]"
                    @click.prevent="downloadPdf">
                  <svg width="19" height="19" class="icon icon-pdf">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pdf"></use>
                  </svg>
                  <span>{{ pdfButtonLabel }}</span>
                </a>
              </div>
              <ul class="itinerary-aside__menu">
                <li
                    v-for="(item, index) in fullMenu"
                    :key="index"
                    :class="[
                    {
                      active: !isShort
                        ? index === activeDay
                        : 'day' + (index + 1) === clickedBlock,
                    },
                  ]"
                    v-if="
                    item.type.includes('CLIMBING') ||
                    item.type === 'SAFARI_PARK' ||
                    item.type === 'SAFARI_ACTIVITY' ||
                    item.type.includes('ACTIVITY') ||
                    item.type.includes('ARRIVAL') ||
                    item.type.includes('DEPARTURE') ||
                    item.type.includes('REST_DAY') ||
                    item.type.includes('OWN_ARRANGEMENTS') ||
                    item.type.includes('ISLAND')
                  ">
                  <a
                      @click="scrollToBlock('#day' + (index + 1))"
                      :class="['js-scr', {active: false}]">
                    <i
                        :class="
                        'icon-' +
                        (item.type.includes('CLIMBING')
                          ? fullMenu[index - 1] &&
                            (fullMenu[index - 1].name.includes('Summit') ||
                              fullMenu[index - 1].name.includes('штурм'))
                            ? 'finish'
                            : 'mountain'
                          : item.type.includes('ARRIVAL') ||
                            item.type.includes('DEPARTURE') ||
                            item.type.includes('FLIGHT')
                          ? 'airplane'
                          : item.type.includes('SAFARI')
                          ? 'pawprint'
                          : item.type.includes('ACCOMMODATION')
                          ? 'bed2'
                          : item.type.includes('OWN_ARRANGEMENTS')
                          ? 'bed2'
                          : item.type.includes('REST_DAY')
                          ? 'bed2'
                          : item.type.includes('ISLAND')
                          ? 'palm-aside'
                          : item.type.includes('INFO')
                          ? 'close'
                          : item.type.includes('ACTIVITY')
                          ? 'air-balloon'
                          : '')
                      ">
                      <svg v-if="item.type.includes('ISLAND')" height="32px">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-palm-aside"></use>
                      </svg>
                    </i>
                    <span>
                      <span>{{
                          program.frontendMeta.tourStart
                              ? item.date.split(' ')[0] +
                              ' ' +
                              item.date.split(' ')[1].substring(0, 3)
                              : $t("common.day_one") + ' ' + item.day
                        }}
                      </span>
                      -
                      <span v-if="item.dateTo">{{
                          program.frontendMeta.tourStart
                              ? item.dateTo.split(' ')[0] +
                              ' ' +
                              item.dateTo.split(' ')[1].substring(0, 3)
                              : $t("common.day_one") + ' ' + item.day
                        }}</span>
                      <span v-if="item.dateTo">-</span>
                      {{
                        item.type.includes('CLIMBING') &&
                        fullMenu[index - 1] &&
                        fullMenu[index - 1].name.includes('SUMMIT')
                            ? $t("common.summitDay")
                            : item.name
                      }}</span
                    ></a
                  >
                </li>
                <li v-if="!program.header.itineraryWithoutPrice && !hidePrice">
                  <a @click="scrollToBlock('#itinerary-summary')" class="js-scr"
                  ><i class="icon-dollar"></i
                  ><span>{{ $t("common.priceForTrip") }}</span></a>
                </li>
                <li
                    v-if="program.details.climbing">
                  <a
                      @click="scrollToBlock('#itinerary-climbing')"
                      class="js-scr"
                  ><i class="icon-mountain"></i
                  ><span>
                      <span>{{ $t("common.climbing") }}</span
                      > - {{ $t("common.costIncludesAndExcludes") }}</span
                  ></a
                  >
                </li>
                <li
                    v-if="program.details.safari">
                  <a @click="scrollToBlock('#itinerary-safari')" class="js-scr"
                  ><i class="icon-pawprint"></i
                  ><span>
                      <span>{{ $t("common.safari") }}</span
                      > - {{ $t("common.costIncludesAndExcludes") }}</span
                  ></a
                  >
                </li>
              </ul>
              <!-- <ul class="itinerary-aside__menu-short" v-else>
                <li>
                  <a href="#day29apr" class="active js-scr"><i class="icon-airplane"></i><span><span>29 APR</span> - Arrival in Tanzania</span></a>
                </li>
                <li>
                  <a href="#day30apr" class="js-scr"><i class="icon-mountain"></i><span><span>30 APR</span> - Start of Kilimanjaro Climbing</span></a>
                </li>
                <li>
                  <a href="#day06may" class="js-scr"><i class="icon-mountain"></i><span><span>06 MAY</span> - Finish of Kilimanjaro Climbing</span></a>
                </li>
                <li>
                  <a href="#day07may" class="js-scr"><i class="icon-pawprint"></i><span><span>7 MAY</span> - Safari in Tarangire</span></a>
                </li>
                <li>
                  <a href="#day08may" class="js-scr"><i class="icon-pawprint"></i><span><span>8 MAY</span> - Safari in Lake Manyara</span></a>
                </li>
                <li>
                  <a href="#day09may" class="js-scr"><i class="icon-pawprint"></i><span><span>9 MAY</span> - Safari in Ngorongoro crater</span></a>
                </li>
                <li>
                  <a href="#day10may" class="js-scr"><i class="icon-air-balloon"></i><span><span>10 MAY</span> - Safari in Serengeti. Hot air balloon</span></a>
                </li>
                <li>
                  <a href="#day11may" class="js-scr"><i class="icon-bed2"></i><span><span>11 MAY</span> - Mount Meru Hotel</span></a>
                </li>
                <li>
                  <a href="#day12may" class="js-scr"><i class="icon-kompass"></i><span><span>12 MAY</span> - Materuni waterfall</span></a>
                </li>
                <li>
                  <a href="#day13may" class="js-scr"><i class="icon-close"></i><span><span>13 MAY - 15 may</span> - no any bookings with us (until 16 may)</span></a>
                </li>
                <li>
                  <a href="#day16may" class="js-scr"><i class="icon-airplane"></i><span><span>16 may</span> - Departure</span></a>
                </li>
                <li>
                  <a href="#itinerary-summary" class="js-scr"><i class="icon-dollar"></i><span>Price for the Trip</span></a>
                </li>
                <li>
                  <a href="#itinerary-climbing" class="js-scr"><i class="icon-mountain"></i><span> <span>CLIMBING</span> cost Includes & Excludes</span></a>
                </li>
                <li>
                  <a href="#itinerary-safari" class="js-scr"><i class="icon-pawprint"></i><span> <span>SAFARI</span> cost Includes & Excludes</span></a>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
      <div class="modal-wrapper" v-if="modalPayStripeShow">
        <div class="modal-backdrop"></div>
        <div class="modal-inner">
          <div class="edit-popup edit-popup--stripe">
            <div class="edit-popup__close" @click="modalPayStripeShow = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
            <div class="edit-popup__title">
              <span>Pay online via Stripe</span>
            </div>
            <div class="edit-popup__desc">
              Use the form below to pay for your lifetime adventure in Africa!
              Thanks for your trust in Altezza Travel.
            </div>
            <form @submit.prevent>
              <div class="form-control-group">
                <label class="form-control-label" for="amount">
                  Payment amount* $
                </label>
                <div
                    :class="[
                    'form-control-wrap',
                    {'is-error': formPayStripeAmountError},
                  ]">
                  <input
                      type="number"
                      class="form-control"
                      id="amount"
                      @focus="formPayStripeAmountError = false"
                      v-model.number="formPayStripe.amount" />
                </div>
              </div>
              <div class="form-control-group">
                <label class="form-control-label" for="comment">
                  Comment (Optional)
                </label>
                <div class="form-control-wrap">
                  <textarea
                      class="form-control"
                      id="comment"
                      placeholder=""
                      v-model.trim="formPayStripe.comment">
                  </textarea>
                </div>
              </div>
              <div class="edit-popup--stripe__submit">
                <button class="btn btn--green" @click="onSubmitPayStripe">
                  <span>Pay for your trip!</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-wrapper" v-if="isModalSendBalloonOptions">
        <div class="modal-backdrop"></div>

        <div class="modal-inner">
          <!--TODO-->
          <!--TODO-->
          <!--TODO-->
          <div class="edit-popup edit-popup--balloon">
            <div class="edit-popup__close" @click="closeModalSendBalloonOptions">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
            <div class="edit-popup__title">
              <span>{{ $t("itinerary.safariOnAirBalloon") }}</span>
            </div>
            <form @submit.prevent>
              <div class="form-control-group">
                <label class="form-control-label" for="amount">
                  {{ $t("itinerary.howManyPeopleOnSafari") }}
                </label>
                <div
                    :class="[
                    'form-control-wrap',
                    {'is-error': formBalloonError},
                  ]">
                  <input
                      type="number"
                      class="form-control"
                      id="amount"
                      :placeholder="$t('common.typePax')"
                      @focus="formBalloonError = false"
                      v-model.number="balloonOptions.pax" />
                </div>
              </div>
              <div class="form-control-group">
                <label class="form-control-label" for="comment">
                  {{ $t("common.note") }}
                </label>
                <div class="form-control-wrap">
                  <textarea
                      class="form-control form-control--balloon"
                      id="comment"
                      :placeholder="$t('common.leaveAnyComments')"
                      v-model.trim="balloonOptions.note">
                  </textarea>
                </div>
              </div>
              <div class="edit-popup--balloon__submit">
                <button @click="closeModalSendBalloonOptions" class="btn btn--silver">
                  <span>{{ $t("common.cancel") }}</span>
                </button>
                <button @click="sendBalloonUserOptions" class="btn btn--green">
                  <span>{{ $t("common.request") }}</span>
                </button>
              </div>
            </form>
          </div>

        </div>

        <div v-if="isModalBalloonSendResult" class="main-content">
          <div class="container-lg">
            <div class="balloon-result">
              <div class="modal-wrapper">
                <div class="modal-backdrop"></div>
                <div class="modal-inner" style="align-items: flex-start;">
                  <a-t-loader class="balloon__loading" v-if="isSendBalloon"/>
                  <div v-else class="edit-popup edit-popup--balloon-total-amount">

                    <div v-if="messageBalloon.code !== 200" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#F13C3C"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                          <g clip-path="url(#clip0_4917_4790)">
                            <path d="M21.876 18.8091L15.7939 8.27294C15.4414 7.66244 14.5586 7.66244 14.2061 8.27294L8.12397 18.8091C7.77143 19.4196 8.21283 20.1849 8.91791 20.1849H21.0821C21.7872 20.1849 22.2286 19.4196 21.876 18.8091ZM15.0086 11.5175C15.3984 11.5175 15.7137 11.8414 15.7022 12.2312L15.5876 16.2324C15.579 16.5477 15.321 16.797 15.0057 16.797C14.6904 16.797 14.4325 16.5448 14.4239 16.2324L14.3121 12.2312C14.3035 11.8414 14.6159 11.5175 15.0086 11.5175ZM15 18.7546C14.6016 18.7546 14.2777 18.4308 14.2777 18.0324C14.2777 17.634 14.6016 17.3101 15 17.3101C15.3984 17.3101 15.7223 17.634 15.7223 18.0324C15.7223 18.4308 15.3984 18.7546 15 18.7546Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_4917_4790">
                              <rect width="14" height="14" fill="white" transform="translate(8 7)"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span>{{ $t("common.cantSendRequest") }}</span>
                      </div>
                      <div class="desc">
                        <span> {{ $t("common.cantSendRequestText") }}</span>
                      </div>
                      <div class="btn">
                        <div @click="isModalBalloonSendResult = false" class="btn btn--green">
                          <span>{{ $t("common.okGotIt") }}</span>
                        </div>
                      </div>
                    </div>

                    <div v-if="messageBalloon.code === 200" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#77B017"/>
                          <path d="M13.595 19.8266C13.4805 19.9379 13.3242 20 13.1619 20C12.9995 20 12.8432 19.9379 12.7287 19.8266L9.26926 16.4847C8.91025 16.1379 8.91025 15.5756 9.26926 15.2295L9.70243 14.811C10.0616 14.4642 10.643 14.4642 11.0021 14.811L13.1619 16.8972L18.9979 11.2601C19.3571 10.9133 19.9391 10.9133 20.2976 11.2601L20.7307 11.6786C21.0898 12.0253 21.0898 12.5875 20.7307 12.9338L13.595 19.8266Z" fill="white"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                        </svg>
                        <span>{{ $t("common.successfullySent") }}</span>
                      </div>
                      <div class="desc">
                        <span>{{ $t("common.successfullySentText") }}</span>
                      </div>
                      <div class="btn">
                        <div @click="isModalBalloonSendResult = false, closeModalSendBalloonOptions()" class="btn btn--green">
                          <span>{{ $t("common.ok") }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-wrapper" v-if="isModalSendPortableToilet">
        <div class="modal-backdrop"></div>

        <div class="modal-inner">
          <!--TODO-->
          <!--TODO-->
          <!--TODO-->
          <div class="edit-popup edit-popup--balloon">
            <div class="edit-popup__close" @click="closeModalSendBalloonOptions">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
            <div class="edit-popup__title">
              <span>{{ $t("itinerary.addPortableToiletToClimb") }}</span>
            </div>
            <form @submit.prevent>
              <div class="special-offer-modal__p">
                <span class="special-offer-modal__p__label">
                  {{ $t("common.readyToShare") }}
                </span>
                <div>
                  <ClassicSwitch v-model="portableToiletOptions.readyToShare"/>
                </div>
              </div>
              <div class="form-control-group">
                <label class="form-control-label" for="comment">
                  {{ $t("common.note") }}
                </label>
                <div class="form-control-wrap">
                  <textarea
                      class="form-control form-control--balloon"
                      id="comment"
                      :placeholder="$t('common.leaveAnyComments')"
                      v-model.trim="portableToiletOptions.note">
                  </textarea>
                </div>
              </div>
              <div class="edit-popup--balloon__submit">
                <button @click="closeModalSendPortableToiletOptions" class="btn btn--silver">
                  <span>{{ $t("common.cancel") }}</span>
                </button>
                <button @click="sendPortableToiletOptionsFc" class="btn btn--green">
                  <span>{{ $t("common.request") }}</span>
                </button>
              </div>
            </form>
          </div>

        </div>

        <div v-if="isModalBalloonSendResult" class="main-content">
          <div class="container-lg">
            <div class="balloon-result">
              <div class="modal-wrapper">
                <div class="modal-backdrop"></div>
                <div class="modal-inner" style="align-items: flex-start;">
                  <a-t-loader class="balloon__loading" v-if="isSendBalloon"/>
                  <div v-else class="edit-popup edit-popup--balloon-total-amount">

                    <div v-if="messageBalloon.code !== 200" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#F13C3C"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                          <g clip-path="url(#clip0_4917_4790)">
                            <path d="M21.876 18.8091L15.7939 8.27294C15.4414 7.66244 14.5586 7.66244 14.2061 8.27294L8.12397 18.8091C7.77143 19.4196 8.21283 20.1849 8.91791 20.1849H21.0821C21.7872 20.1849 22.2286 19.4196 21.876 18.8091ZM15.0086 11.5175C15.3984 11.5175 15.7137 11.8414 15.7022 12.2312L15.5876 16.2324C15.579 16.5477 15.321 16.797 15.0057 16.797C14.6904 16.797 14.4325 16.5448 14.4239 16.2324L14.3121 12.2312C14.3035 11.8414 14.6159 11.5175 15.0086 11.5175ZM15 18.7546C14.6016 18.7546 14.2777 18.4308 14.2777 18.0324C14.2777 17.634 14.6016 17.3101 15 17.3101C15.3984 17.3101 15.7223 17.634 15.7223 18.0324C15.7223 18.4308 15.3984 18.7546 15 18.7546Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_4917_4790">
                              <rect width="14" height="14" fill="white" transform="translate(8 7)"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span>{{ $t("common.cantSendRequest") }}</span>
                      </div>
                      <div class="desc">
                        <span> {{ $t("common.cantSendRequestText") }}</span>
                      </div>
                      <div class="btn">
                        <div @click="isModalBalloonSendResult = false" class="btn btn--green">
                          <span>{{ $t("common.okGotIt") }}</span>
                        </div>
                      </div>
                    </div>

                    <div v-if="messageBalloon.code === 200" class="result-card">
                      <div class="title">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15" cy="15" r="15" fill="#77B017"/>
                          <path d="M13.595 19.8266C13.4805 19.9379 13.3242 20 13.1619 20C12.9995 20 12.8432 19.9379 12.7287 19.8266L9.26926 16.4847C8.91025 16.1379 8.91025 15.5756 9.26926 15.2295L9.70243 14.811C10.0616 14.4642 10.643 14.4642 11.0021 14.811L13.1619 16.8972L18.9979 11.2601C19.3571 10.9133 19.9391 10.9133 20.2976 11.2601L20.7307 11.6786C21.0898 12.0253 21.0898 12.5875 20.7307 12.9338L13.595 19.8266Z" fill="white"/>
                          <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                        </svg>
                        <span>{{ $t("common.successfullySent") }}</span>
                      </div>
                      <div class="desc">
                        <span>{{ $t("common.successfullySentText") }}</span>
                      </div>
                      <div class="btn">
                        <div @click="isModalBalloonSendResult = false, closeModalSendBalloonOptions()" class="btn btn--green">
                          <span>{{ $t("common.ok") }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-wrapper" v-if="isModalUpgradeAccommodation">
        <div class="modal-backdrop"></div>
        <div class="modal-inner">
          <div class="edit-popup edit-popup--stripe">
            <div class="edit-popup__close" @click="isModalUpgradeAccommodation = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
            <div class="edit-popup__title">
              <span style="text-transform: none">{{ $t("common.upgradeToSingleRoom") }}</span>
            </div>
            <div class="edit-popup__desc" style="font-size: 15px; line-height: 1.6; color: #000000">
              {{ $t("itinerary.whenWantSingleRoom") }}
            </div>
            <div>
              <div class="itinerary-shared-accommodation__switch-wrapper">
                <span>{{ $t("common.nightBeforeClimb") }} - {{
                    getCurrencySign(program.header.currency)
                  }}{{upgradeAccommodationData.price}}</span>
                <ClassicSwitch v-model="upgradeAccommodationData.before" @input="upgradeAccommodationData.errors.atLeastOne = false"/>
              </div>
              <div class="itinerary-shared-accommodation__switch-wrapper">
                <span>{{ $t("common.nightAfterClimb") }} - {{
                    getCurrencySign(program.header.currency)
                  }}{{upgradeAccommodationData.price}}</span>
                <ClassicSwitch v-model="upgradeAccommodationData.after" @input="upgradeAccommodationData.errors.atLeastOne = false"/>
              </div>
              <div class="itinerary-shared-accommodation__error" v-if="upgradeAccommodationData.errors.atLeastOne">
                {{ $t("common.atLeastOneToggle") }}
              </div>
            </div>
            <div class="itinerary-shared-accommodation__total-price-wrapper">
              <div>{{upgradeToSingleRoomPriceMessage}}</div>
              <div>{{ $t("common.total") }}: {{
                  getCurrencySign(program.header.currency)
                }}{{upgradeToSingleRoomPrice}}</div>
            </div>
            <div style="display:flex; justify-content: center;">
              <div class="itinerary-shared-accommodation__button" style="text-transform: none" :disabled="!upgradeAccommodationData.before && !upgradeAccommodationData.after" @click="handleUpgradeSingleRoom()">
                {{ $t("common.payNow") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-wrapper" v-if="isModalVideoReview">
        <div class="modal-backdrop"></div>
        <div class="modal-inner" @click.self="isModalVideoReview = false; modalVideoReviewURL = '';">
          <div class="edit-popup videoReview_modal">
            <div class="edit-popup__close" @click="isModalVideoReview = false; modalVideoReviewURL = '';">
              <svg width="2em" height="2em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
            <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${getYTVideoID(modalVideoReviewURL)}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>

    </main>
    <footer class="footer" v-if="program">
      <div class="container-fluid">
        <div class="footer-inner-s">
          <div class="footer-logo">
            <img
                v-if="branding === 'false'"
                src="/images/footer-logo.svg"
                alt="" />
            <img
                v-else-if="branding === 'true'"
                src="/images/luxury-short-safari.svg"
                alt="" />
          </div>
          <ul class="footer-info">
            <li>
              <span>Manager’s contact:</span>
              <a
                  :href="
                  'tel:' +
                  program.header.office.manager.phone.replaceAll(' ', '')
                ">
                {{ program.header.office.manager.phone }}
              </a>
              {{ program.header.office.manager.name }}
              <div class="footer-info__social">
                <a
                    :href="
                    'tg://resolve?domain=' +
                    program.header.office.manager.telegram
                  "
                ><img src="/images/icons/telegram.svg" class="js-lazy" alt=""
                /></a>
                <a
                    :style="{
                    opacity: program.header.office.manager.whatsapp ? 1 : 0,
                    visibility: program.header.office.manager.whatsapp
                      ? 'visible'
                      : 'hidden',
                  }"
                    :href="
                    'https://wa.me/' +
                    program.header.office.manager.whatsapp.replaceAll(' ', '')
                  "
                ><img src="/images/icons/whatsapp.svg" class="js-lazy" alt=""
                /></a>
              </div>
            </li>
            <li>
              <span v-if="branding === 'false'">Altezza Hotline:</span>
              <span v-else-if="branding === 'true'">Hotline:</span>
              <a :href="'tel:' + program.header.office.hotline"
              >+{{
                  program.header.office.hotline
                      ? new Intl.NumberFormat('ru-RU').format(
                          +program.header.office.hotline.replace('+', '')
                      )
                      : ''
                }}</a
              >
              <div class="footer-info__social">
                <a :href="program.header.office.telegram"
                ><img src="/images/icons/telegram.svg" class="js-lazy" alt=""
                /></a>
                <a :href="program.header.office.whatsapp"
                ><img src="/images/icons/whatsapp.svg" class="js-lazy" alt=""
                /></a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Vuex from "vuex";
import {getItinerary, API, upgradeToSingleRoom} from '@/utilites/api'
import ATLoader from "@/components/Loaders/Loader";
import {Fancybox} from '@fancyapps/ui'
import {format, parse} from 'date-fns'
import {
  actionTypes as actionTypesSettings,
  getterTypes as getterTypesSettings
} from "@/store/modules/settings";
import HotelCheckInOutTimeLabel from "@/components/HotelCheckInOutTime/HotelCheckInOutTimeLabel";
import ItineraryIncludesExcludesSpoiler
  from "@/components/ItineraryIncludesExcludesSpoiler/ItineraryIncludesExcludesSpoiler.vue";
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
import ClassicSwitch from "@/components/UI/Switch/ClassicSwitch.vue";
import {getCurrencySign} from '../common/helpers/currency'

export default {
  data() {
    return {
      formPayStripe: {
        amount: null,
        comment: '',
      },
      isModalSendPortableToilet: false,
      isModalPortableToiletSendResult: false,
      isModalUpgradeAccommodation: false,
      isModalVideoReview: false,
      modalVideoReviewURL: '',
      upgradeAccommodationData: {
        programId: null,
        before: true,
        after: false,
        successUrl: null,
        price: 0,
        errors: {
          atLeastOne: false
        }
      },
      modalPortableToiletError: false,
      portableToiletOptions: {
        clientId: null,
        readyToShare: false,
        note: ''
      },
      isModalSendBalloonOptions: false,
      isModalBalloonSendResult: false,
      formBalloonError: false,
      balloonSuggestionBtn: false,
      balloonOptions: {
        clientId: null,
        pax: null,
        note: ''
      },
      formPayStripeAmountError: false,
      modalPayStripeShow: false,
      program: null,
      isShort: false,
      isPdfDownloading: false,
      areImagesReady: false,
      imageLoadCheckId: 0,
      activeDay: 0,
      API: API,
      openMenu: false,
      collapse: {
        climbing: {
          transfers: false,
          fees: false,
          accom: false,
          meals: false,
          hiking: false,
          climbingCrew: false,
          taxes: false,
        },
        safari: {
          transfers: false,
          fees: false,
          accom: false,
          crew: false,
          meals: false,
          hiking: false,
        },
      },
      clickedBlock: null,
    }
  },
  components: {ClassicSwitch, BasicInput, ItineraryIncludesExcludesSpoiler, HotelCheckInOutTimeLabel, ATLoader},
  mounted() {
    this.updateData()
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          chain: false,
          type: false,
          location: false,
          area: false,
          mobileArea: false,
          mobileClosest: false,
          airport: false,
        }
      }
    })
    // $('.itinerary-day__rooming-title').on('click', function (e) {
    // 	e.preventDefault();
    // 	$(this).parent().toggleClass('active');
    // 	$(this).parent().find('.itinerary-day__rooming-content').slideToggle();
    // });
    // $('.itinerary-day__participants-title').on('click', function (e) {
    // 	e.preventDefault();
    // 	$(this).parent().toggleClass('active');
    // 	$(this).parent().find('.itinerary-day__participants-content').slideToggle();
    // });

    window.addEventListener('scroll', () => {
      if (!this.isShort) {
        this.activeDay = Array.from(
            document.querySelectorAll('.itinerary-day__item-scroll')
        )
            .map((elem) => elem.getBoundingClientRect().top)
            .findIndex((elem) => elem >= 0)
      } else {
        this.activeDay = Array.from(
            document.querySelectorAll('.itinerary-day__item-scroll')
        )
            .map((elem) => elem.getBoundingClientRect().top)
            .findIndex((elem) => elem >= 0)
      }
    })
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      sendBalloonOptions: actionTypesSettings.sendBalloonOptions,
      sendPortableToiletOptions: actionTypesSettings.sendPortableToiletOptions,
    }),
    downloadPdf() {
      if (this.isPdfButtonDisabled) {
        return
      }

      const wasShort = this.isShort
      const previousTitle = document.title
      let fallbackTimer = null
      const cleanup = () => {
        document.body.classList.remove('itinerary-pdf-mode')
        this.clearPrintFirstDayItems()
        document.title = previousTitle
        this.isShort = wasShort
        this.isPdfDownloading = false

        if (fallbackTimer) {
          clearTimeout(fallbackTimer)
        }
      }

      try {
        this.isPdfDownloading = true
        this.openMenu = false
        this.isShort = false
        document.body.classList.add('itinerary-pdf-mode')
        document.title = this.getPdfTitle()

        this.$nextTick(() => {
          this.preparePrintFirstDayItems()
          window.addEventListener('afterprint', cleanup, {once: true})
          fallbackTimer = setTimeout(cleanup, 60000)
          window.print()
        })
      } catch (error) {
        cleanup()
        console.error('Itinerary print export failed', error)
      }
    },
    getPdfTitle() {
      const groupName = this.program && this.program.header && this.program.header.groupName
          ? this.program.header.groupName
          : 'itinerary'

      return `${groupName} \uFF5C Altezza Travel`
          .replace(/[\\/:*?"<>]+/g, '-')
          .replace(/\s+/g, ' ')
          .trim()
          .slice(0, 120)
    },
    preparePrintFirstDayItems() {
      this.clearPrintFirstDayItems()

      document.querySelectorAll('.itinerary-day').forEach((day) => {
        const firstItem = day.querySelector('.itinerary-day__item')

        if (firstItem) {
          const date = Array.from(day.children).find((child) => (
            child.classList && child.classList.contains('itinerary-day__date')
          ))
          const top = firstItem.querySelector('.itinerary-day__top') ||
              day.querySelector('.itinerary-day__top')

          if (date && top) {
            const printHeading = document.createElement('div')
            const printDate = date.cloneNode(true)
            const printTop = top.cloneNode(true)

            printHeading.classList.add('itinerary-day__print-heading')
            printDate.classList.add('itinerary-day__date--print-clone')
            printTop.classList.add('itinerary-day__top--print-clone')

            printHeading.appendChild(printDate)
            printHeading.appendChild(printTop)
            firstItem.insertBefore(printHeading, firstItem.firstChild)
            top.classList.add('itinerary-day__top--print-hidden')
            day.classList.add('itinerary-day--print-prepared')
          }

          firstItem.classList.add('itinerary-day__item--print-first')
        }
      })
    },
    clearPrintFirstDayItems() {
      document
          .querySelectorAll('.itinerary-day__print-heading')
          .forEach((heading) => heading.remove())
      document
          .querySelectorAll('.itinerary-day__top--print-hidden')
          .forEach((top) => top.classList.remove('itinerary-day__top--print-hidden'))
      document
          .querySelectorAll('.itinerary-day--print-prepared')
          .forEach((day) => day.classList.remove('itinerary-day--print-prepared'))
      document
          .querySelectorAll('.itinerary-day__item--print-first')
          .forEach((item) => item.classList.remove('itinerary-day__item--print-first'))
    },
    getYTVideoID(url) {
      try {
        const parsedUrl = new URL(url);
        // If short form https://youtu.be/VIDEO_ID
        if (parsedUrl.hostname === 'youtu.be') {
          return parsedUrl.pathname.slice(1);
        }
        // If default form https://www.youtube.com/watch?v=VIDEO_ID
        if (parsedUrl.hostname.includes('youtube.com')) {
          return parsedUrl.searchParams.get('v');
        }
        return null;
      } catch {
        return null;
      }
    },
    handleUpgradeSingleRoom() {
      if (this.upgradeAccommodationData.before || this.upgradeAccommodationData.after) {
        this.upgradeAccommodationData.errors.atLeastOne = false;
        upgradeToSingleRoom({
          "programId": this.upgradeAccommodationData.programId,
          "beforeClimbing": this.upgradeAccommodationData.before,
          "afterClimbing": this.upgradeAccommodationData.after,
          "successUrl": window.location.href,
          "cancelUrl": window.location.href
        }).then((res) => {
          window.location.href = res.sessionUrl;
        });
      } else {
        this.upgradeAccommodationData.errors.atLeastOne = true;
      }
    },
    closeModalSendPortableToiletOptions(){
      this.isModalSendPortableToilet = false
      this.portableToiletOptions.note = ''
      this.portableToiletOptions.readyToShare = false
      this.modalPortableToiletError = false
    },
    closeModalSendBalloonOptions(){
      this.isModalSendBalloonOptions = false
      this.balloonOptions.note = ''
      this.balloonOptions.pax = ''
      this.balloonOptions.clientId = null
      this.formBalloonError = false
    },
    sendPortableToiletOptionsFc(){
      this.sendPortableToiletOptions(this.portableToiletOptions).then((res) => {
        this.closeModalSendPortableToiletOptions();
        this.isModalPortableToiletSendResult = true
      })
    },
    sendBalloonUserOptions(){
      if (this.balloonOptions.pax) {
        this.isModalBalloonSendResult = true
        this.sendBalloonOptions(this.balloonOptions).then(() => {
          this.balloonSuggestionBtn = true
        })
      } else {
        this.formBalloonError = true
      }
    },
    getTimeFromMins(mins, lang) {
      if (lang === 'EN') {
        if (mins < 60) {
          return mins + 'm'
        } else {
          let hours = Math.trunc(mins/60);
          let minutes = mins % 60;

          return minutes > 0 ? hours + 'h' + ' ' + minutes + 'm' : hours + 'h'
        }
      }
      if (lang === 'RU') {
        if (mins < 60) {
          return mins + 'мин'
        } else {
          let hours = Math.trunc(mins/60);
          let minutes = mins % 60;

          return minutes > 0 ? hours + 'ч' + ' ' + minutes + 'мин' : hours + 'ч'
        }
      }
      if (lang === 'DE') {
        if (mins < 60) {
          return mins + 'Min.'
        } else {
          let hours = Math.trunc(mins/60);
          let minutes = mins % 60;

          return minutes > 0 ? hours + 'Std.' + ' ' + minutes + 'Min.' : hours + 'Std.'
        }
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    calculateHours(durationMinutes) {
      const hours = parseInt(durationMinutes / 60)
      return hours > 0 ? this.$tc('common.hour', hours) : ''
    },
    calculateMinutes(durationMinutes) {
      const minutes = parseInt(durationMinutes % 60)
      return minutes > 0 ? `${minutes} ${this.$t("common.minutes_many")}` : ''
    },
    showFormattedParticipants(participants) {
      participants = participants.map((item) => {
        let strings = item.split('-')
        strings[0] = strings[0].trim()
        return strings.join()
      })
      return participants.join(', ')
    },
    onSubmitPayStripe() {
      if (!this.formPayStripe.amount) {
        this.formPayStripeAmountError = true
        return false
      }
      // TODO: add submit handle
      this.modalPayStripeShow = false
      this.formPayStripeAmountError = false
      this.formPayStripe = {
        amount: null,
        comment: '',
      }
    },
    zoomImage(photos, selected) {
      const selectedFirst = [selected, ...photos.filter(p => p !== selected)]
      Fancybox.show(
          selectedFirst
              .map(p => ({
                src: `${this.API}/documents/share/images/${p}?size=MEDIUM`,
                type: 'image',
              }))
      )
    },
    isShowHotelNotBookedAlert(status) {
      switch (status) {
        case 'LEAD':
        case 'NEGOTIATION':
        case 'POSTPONE':
        case 'CANCELLED':
        case 'DELETED':
        case 'NO_RESPONSE_1':
        case 'NO_RESPONSE_2':
        case 'PROPOSAL':
          return true;
        default :
          return false;
      }
    },
    updateData() {
      getItinerary(this.$route.params.link).then((res) => {
        // console.log('GET Itinerary in this.program', res)
        this.program = res
        this.$setLocale(res.header.lang);
        if (this.program.frontendMeta.tourStart) {
          document.title = `${this.program.header.groupName} | ${format(
              new Date(
                  parse(
                      this.program.frontendMeta.tourStart,
                      'dd.MM.yyyy',
                      new Date()
                  )
              ),
              'dd MMM yyyy'
          )} - ${format(
              new Date(
                  parse(
                      this.program.frontendMeta.tourFinish,
                      'dd.MM.yyyy',
                      new Date()
                  )
              ),
              'dd MMM yyyy'
          )}`
        } else {
          document.title = this.program.header.groupName
        }
        // document.title = this.program.header.groupName + ' | ' + (this.program.frontendMeta.tourStart && this.program.frontendMeta.tourFinish ? (this.program.header.travelDates.start.split(' ')[2] === this.program.header.travelDates.finish.split(' ')[2] && this.program.header.travelDates.start.split(' ')[1] === this.program.header.travelDates.finish.split(' ')[1] ? this.program.header.travelDates.start.split(' ')[0] + ' - ' + this.program.header.travelDates.finish.split(' ')[0] + ' ' + this.program.header.travelDates.finish.split(' ')[1] + ' ' + this.program.header.travelDates.finish.split(' ')[2] : this.program.header.travelDates.start.split(' ')[2] === this.program.header.travelDates.finish.split(' ')[2] ? this.program.header.travelDates.start.split(' ')[0] + ' ' + this.program.header.travelDates.start.split(' ')[1] + ' - ' + this.program.header.travelDates.finish.split(' ')[0] + ' ' + this.program.header.travelDates.finish.split(' ')[1] + ' ' + this.program.header.travelDates.finish.split(' ')[2] : '') : 'To be confirmed')

        this.$nextTick(() => {
          document.querySelectorAll('.spoiler-header').forEach((elem) => {
            elem.addEventListener('click', () => {
              elem.parentElement.classList.toggle('active')
            })
          })
          document
              .querySelectorAll(
                  '.itinerary-day__rooming-title, .itinerary-day__participants-title'
              )
              .forEach((elem) => {
                elem.addEventListener('click', () => {
                  elem.parentElement.classList.toggle('active')
                })
              })
          this.trackImageReadiness()
        })
      })
    },
    trackImageReadiness() {
      this.areImagesReady = false

      const checkId = ++this.imageLoadCheckId

      this.$nextTick(() => {
        if (!this.$el || checkId !== this.imageLoadCheckId) {
          return
        }

        const images = Array.from(this.$el.querySelectorAll('img'))

        if (!images.length) {
          this.areImagesReady = true
          return
        }

        let settledImages = 0

        const markSettled = () => {
          settledImages += 1

          if (checkId === this.imageLoadCheckId && settledImages === images.length) {
            this.areImagesReady = true
          }
        }

        images.forEach((img) => {
          if (img.complete) {
            markSettled()
            return
          }

          const handleSettled = () => {
            img.removeEventListener('load', handleSettled)
            img.removeEventListener('error', handleSettled)
            markSettled()
          }

          img.addEventListener('load', handleSettled, {once: true})
          img.addEventListener('error', handleSettled, {once: true})
        })
      })
    },
    scrollToBlock(elem) {
      let block = document.querySelector(elem)
      if (block) {
        if (!this.isShort) block.scrollIntoView({behavior: 'smooth'})
        else {
          const yOffset = -15
          const y =
              block.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({top: y, behavior: 'smooth'})
          this.clickedBlock = block.id
        }
      }
    },
  },
  computed: {
    ...Vuex.mapGetters({
      isSendBalloon: getterTypesSettings.isSendBalloon,
      messageBalloon: getterTypesSettings.messageBalloon
    }),
    upgradeToSingleRoomPriceMessage() {
      const nightsAmount = this.upgradeAccommodationData.before && this.upgradeAccommodationData.after ? 2 : 1;

      return `${getCurrencySign(this.program.header.currency)}${this.upgradeAccommodationData.price} x ${nightsAmount} ${this.$tc("common.night_clear", nightsAmount)}`
    },
    upgradeToSingleRoomPrice() {
      if (!this.upgradeAccommodationData.after && !this.upgradeAccommodationData.before) {
        return 0;
      }

      return this.upgradeAccommodationData.after && this.upgradeAccommodationData.before ? this.upgradeAccommodationData.price * 2 : this.upgradeAccommodationData.price;
    },
    sortedAmenities() {
      return day.hotelInfo.amenities
    },
    branding() {
      return process.env.VUE_APP_BRANDING
    },
    hidePrice() {
      return process.env.VUE_APP_ITINERARY_HIDE_PRICE === "true";
    },
    filteredPax() {
      let counts = {}
      this.program.header.participantCosts.forEach((x) => {
        counts[x.info] = (counts[x.info] || 0) + 1
      })
      return counts
    },
    isPdfButtonDisabled() {
      return this.isPdfDownloading || !this.areImagesReady
    },
    pdfButtonLabel() {
      if (this.isPdfDownloading) {
        return 'Preparing PDF...'
      }

      if (!this.areImagesReady) {
        return 'Loading images...'
      }

      return 'Save as PDF'
    },
    fullMenu() {
      let count = 0
      // console.log('this.program.body.days START', this.program.body.days)
      return this.program.body.days
          .map((item) =>
              item.dayInfo.map((day) => ({
                ...day,
                date: item.date,
                dateTo: item.dateTo
              }))
          )
          .flat()
          .map((item, index) => {
            if (
                item.type.includes('CLIMBING') ||
                item.type === 'SAFARI_PARK' ||
                item.type === 'SAFARI_ACTIVITY' ||
                item.type.includes('ACTIVITY') ||
                item.type.includes('ARRIVAL') ||
                item.type.includes('DEPARTURE') ||
                item.type.includes('REST_DAY') ||
                item.type.includes('OWN_ARRANGEMENTS') ||
                item.type.includes('ISLAND')
            ) {
              if (
                  item.day ||
                  item.type === 'MAINLAND_ACTIVITY' ||
                  item.type === 'ARRIVAL' ||
                  item.type === 'DEPARTURE' ||
                  item.type.includes('CLIMBING') ||
                  item.type.includes('REST_DAY') ||
                  item.type.includes('OWN_ARRANGEMENTS') ||
                  item.type.includes('ISLAND')
              ) {
                count = count + 1
              }
              return {
                ...item,
                day: count,
              }
            }
            return item
          })
    },
  },
  watch: {
    isShort() {
      this.$nextTick(() => {
        document
            .querySelectorAll(
                '.itinerary-day__rooming-title, .itinerary-day__participants-title'
            )
            .forEach((elem) => {
              elem.addEventListener('click', () => {
                elem.parentElement.classList.toggle('active')
              })
            })
        this.trackImageReadiness()
      })
    },
  },
  metaInfo: {
    meta: [
      {name: 'robots', content: 'noindex, follow'},
    ]
  }
}
</script>

<style lang="scss" scoped>
.lowercase-ru {
  text-transform: lowercase;
}
.itinerary-aside .icon-palm-aside {
  margin-right: 0;
  font-size: 15px;
  width: 34px;
  min-width: 20px;
  display: flex;
  justify-content: center;
}


.itinerary-aside__menu li {
  i {
    height: 20px;
  }
  svg {
    fill: #B9B9B9;
    transition: .1s;

  }
}

.itinerary-aside__menu li:hover {
  svg {
    fill: #77b017;
  }
}

.itinerary__booked-by-guest-alert-wrapper {
  display: flex;
  border-radius: 5px;
  border: 1px solid #FFA51F;
  padding: 6px 10px;
  align-items: center;
  margin-bottom: 15px;
}

.itinerary__booked-by-guest-alert-icon {
  margin-right:  12px;
}

.itinerary__booked-by-guest-alert-text {
  text-transform: uppercase;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
}

.itinerary__alert-not-booked {
  display: inline-flex;
  font-weight: 700;
  border-radius: 5px;
  font-size: 15px;
  background: #F5D37F;
  padding: 5px 10px;
}

.kindly-note {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px dashed rgba(200, 200, 200, 0.4);

  &__icon {
    display: flex;
    justify-content: center;
    margin-right: 1.3rem;
    width: 35px;
  }

  &__text {
    font-size: 15px;

    & strong {
      text-transform: uppercase;
    }
  }
}
.special-offer-modal__p {
  display: flex;
  align-items: center;
  margin: 30px 0;

  &__label {
    display: inline-flex;
    margin-right: 20px;
    width: unset;
    color: #2e2e2e;
    font-family: "sfuitext", sans-serif;
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
    cursor: pointer;
  }
}
.premium-option {
  &__wrapper {
    margin: 120px 0 0;
    position: relative;

    &-bordered {
      margin: 50px 0 0;
      border: 1px solid #DDDDDD;
      border-radius: 10px;
      padding: 30px;
    }
  }
  &__title {
    position: relative;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
    color: #202020;
    text-transform: none;
    z-index: 5;
  }

  &__title-secondary {
    position: relative;
    color: #606060;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    z-index: 5;

    a {
      font-weight: bold;
    }
  }

  &__second-part {
    position: relative;
  }

  &__third-part {
    display: flex;
    align-items: center;
    margin-top: 20px;
    img:first-child {
      margin-right: 40px;
    }
  }

  &__text {
    margin-top: 20px;
    position: relative;
    border: 1px solid #DDD;
    filter: drop-shadow(0px 1px 9px rgba(0, 0, 0, 0.06));
    padding: 24px;
    color: #606060;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    border-radius: 10px;
    background: #fff;
    z-index: 5;
  }

  &__info-block {
    width: 53%;
  }

  &__text--double {
    display: flex;
    justify-content: space-between;

    &>div {
      width: 45%;
    }

    &__title {
      color: #202020;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px; /* 200% */
      text-transform: capitalize;
    }

    &-title-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      & svg {
        margin-right: 10px;
      }
    }
  }

  &__image-wrapper {
    position: absolute;
    right: 0;
    transform: translate(0px, -100%);
    z-index: 3;

    &-single {
      transform: none;
      bottom: 0px;

      @media (max-width: 425px) {
        transform: scale(0.6);
        right: -20% !important;
      }
    }

    @media (max-width: 425px) {
      right: -10%;
    }
  }
}
.itinerary-shared-accommodation {
  padding: 25px;
  border-radius: 10px;
  background: #F2F3EF;
  margin: 20px 0;

  &__info-wrapper {
    display: flex;
    gap: 25px;
  }

  &__image {
    display: flex;

    img {
      min-width: 120px;
      height: 155px;
    }
  }

  &__text-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 15px;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
  }

  &__text {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.6;
  }

  &__cta-wrapper {
    border-top: 1px solid #E3E3E3;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
  }

  &__alert {
    font-weight: 700;
    font-size: 15px;
    line-height: 1.5;
  }

  &__button {
    display: flex;
    align-items: center;
    border-radius: 5px;
    color: #ffffff;
    text-transform: uppercase;
    padding: 10px;
    font-weight: 700;
    font-size: 14px;
    background: #77B017;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    transition: background-color .2s ease-in-out;
    width: fit-content;
    height: fit-content;

    &[disabled="disabled"] {
      opacity: 0.5;
    }

    &:hover {
      background: #6da212;
      transition: background-color .2s ease-in-out;
    }
  }

  &__switch-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 15px 0;
    justify-content: space-between;
    max-width: 80%;

    span {
      font-weight: 700;
      font-size: 14px;
    }

  }

  &__total-price-wrapper {
    border-top: 1px solid #DEDEDE;
    border-bottom: 1px solid #DEDEDE;
    padding: 15px 0;
    margin: 20px 0 25px 0;
    display: flex;
    justify-content: space-between;

    div:not(:first-child) {
      font-weight: 700;
      font-size: 15px;
    }
  }

  &__error {
    color: red;
  }
}
.aircraft {
  margin: 15px 0;
  &__plane-wrapper {
    display: flex;
    gap: 20px;

    @media screen and (max-width: 480px) {
      flex-direction: column-reverse;
    }
  }
  &__image {
    img {
      aspect-ratio: 21 / 9;
      max-width: 200px;
      height: auto;
    }
  }

  &__note {
    margin-top: 20px;
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      display: flex;
      flex-shrink: 0;
    }
  }

  &__text {
    font-weight: 700;
    font-size: 15px;
    line-height: 1.5;
  }
}
.itinerary-restrictions-info {
  margin: 20px 0;
  padding-left: 48px;

  &__title-wrapper {
    display: flex;
    gap: 6px;
    align-items: flex-end;
  }

  &__html {
    line-height: 1.5;
    font-size: 14px;
  }

  &__title {
    font-weight: 700;
    font-size: 14px;
  }
}
.videoReview {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #E60000;
  border-radius: 10px;
  height: 35px;
  width: fit-content;
  padding: 0 12px;
  min-width: 144px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  gap: 6px;
  cursor: pointer;
  margin: 20px 0;
  line-height: 24px;
  user-select: none;
  transition: transform .2s ease-in-out;

  &:hover {
    transform: scale(1.025);
  }

  &_modal {
    width: 900px;
    height: 550px;
    padding: 63px 84px 72px;
    background: transparent;
    border: none;
    box-shadow: none;

    @media (max-width: 767px) {
      width: 800px;
      height: 500px;
      padding: 2.6rem 3.5rem 3rem;
    }

    .edit-popup__close {
      position: absolute;
      top: 35px;
      right: 50px;

      svg {
        font-size: 24px !important;
      }

      @media (max-width: 767px) {
        top: 0px;
        right: 5px;
      }
    }
  }

  &_icon {
    display: flex;
  }
}
</style>
<style>
.itinerary-day__content p a {
  text-decoration: none;
  color: inherit;
  border-bottom: 2px solid rgba(119, 176, 23, 0.8);
}
</style>
